// import React, { useState, useEffect, useRef } from "react";
// import "./testscheduling.css";
// import DropDown3 from "./Drodpwon-Catch";
// import InputComponent from "./Input-testscheduling";
// import introgativeImgBlue from "../../../Assets/Images/CommanImages/IntrogativeBlue.png";
// import TextEditor from "../../Landing/components/TextEditor";
// import MinusImg from "../../../Assets/Images/CommanImages/MinusGrey.png";
// import SuccessImg from "../../../Assets/Images/CommanImages/success.png";
// import ErrorImg from "../../../Assets/Images/CommanImages/Error.png";
// import Colors from "../../../Constants/Colors";
// import ReflectDropdown from "../../../Components/ReflectDropdown/ReflectDropdwon";
// import { useNavigate, useSearchParams } from "react-router-dom";
// import { PUT, GET } from "../../../Api/HttpsMethods";
// import EndPoints from "../../../Api/Endpoints";
// import RejectModal from "../../../Components/RejectModal/RejectModal";
// import CoursePlanTable from "./CoursePlanTable";
// // import PreviewQuesPaper from "../PreviewQuesPapers/PreviewQuesPaper";
// import Latex from "react-latex";
// import "katex/dist/katex.min.css";
// import he from "he";

// // ─── helpers ─────────────────────────────────────────────────────────────────
// const getCurrentDateTime = () => {
//   const n = new Date();
//   return (
//     [n.getFullYear(), String(n.getMonth() + 1).padStart(2, "0"), String(n.getDate()).padStart(2, "0")].join("-") +
//     "T" +
//     [String(n.getHours()).padStart(2, "0"), String(n.getMinutes()).padStart(2, "0")].join(":")
//   );
// };

// const toDatetimeLocal = (val) => {
//   if (!val) return "";
//   const d = new Date(val);
//   if (isNaN(d)) return "";
//   return (
//     [d.getFullYear(), String(d.getMonth() + 1).padStart(2, "0"), String(d.getDate()).padStart(2, "0")].join("-") +
//     "T" +
//     [String(d.getHours()).padStart(2, "0"), String(d.getMinutes()).padStart(2, "0")].join(":")
//   );
// };

// // ─── component ───────────────────────────────────────────────────────────────
// const TestSchedulingClone = ({
//   dataClient,
//   setMessageBox,
//   setIsMessageBoxVisible,
//   setActiveImg,
// }) => {
//   const navigate = useNavigate();
//   const [searchParams] = useSearchParams();

//   const quesPaperIdParam = searchParams.get("IDs");
//   const isCancelled      = searchParams.get("isCancelled") === "true";
//   useEffect(() => {
//     if (dataClient) {
//       const u = dataClient?.client_schema_name?.[6]?.[0];
//       if (u?.user_name)        sessionStorage.setItem("user_name",      u.user_name);
//       if (u?.client_branch_id) sessionStorage.setItem("clientBranchId", u.client_branch_id);
//       if (u?.client_id)        sessionStorage.setItem("clientId",        u.client_id);
//     }
//   }, [dataClient]);

//   const userName       = dataClient?.client_schema_name?.[6]?.[0]?.user_name       || sessionStorage.getItem("user_name")      || "";
//   const clientBranchId = dataClient?.client_schema_name?.[6]?.[0]?.client_branch_id || sessionStorage.getItem("clientBranchId") || null;

//   const [allTestSeries,     setAllTestSeries]     = useState([]);
//   const [courses,           setCourses]           = useState([]);
//   const [markingSchemeList, setMarkingSchemeList] = useState([]);
//   const [testTemplates,     setTestTemplates]     = useState([]);

//   const [selectedTestSeriesId,  setSelectedTestSeriesId]  = useState(null);
//   const [selectedTestSeriesObj, setSelectedTestSeriesObj] = useState(null);
//   const [testSeriesDescription, setTestSeriesDescription] = useState("");
//   const [courseOpted,           setCourseOpted]           = useState("");
//   const [quesPaperName,         setQuesPaperName]         = useState("");
//   const [quesPaperDescription,  setQuesPaperDescription]  = useState("");
//   const [quesPaperCreatedBy,    setQuesPaperCreatedBy]    = useState("");
//   const [testSeriesSubjects,    setTestSeriesSubjects]    = useState("");

//   const [testScheduleId, setTestScheduleId] = useState(null);
//   const [scheduleStatus, setScheduleStatus] = useState(1);

//   const isAITS = !!selectedTestSeriesObj?.ts_name?.toUpperCase().includes("AITS");

//   const [testName,         setTestName]         = useState("");
//   const [testDescription,  setTestDescription]  = useState("");
//   const [testWindowStart,  setTestWindowStart]  = useState("");
//   const [testWindowEnd,    setTestWindowEnd]    = useState("");
//   const [duration,         setDuration]         = useState("");
//   const [numberOfSets,     setNumberOfSets]     = useState(1);
//   const [shuffleSubjects,  setShuffleSubjects]  = useState(false);
//   const [shuffleQuestions, setShuffleQuestions] = useState(false);
//   const [shuffleOptions,   setShuffleOptions]   = useState(false);
//   const [instructionsHtml, setInstructionsHtml] = useState("");

//   const [savedLevel1Id, setSavedLevel1Id] = useState(null);
//   const [savedLevel2Id, setSavedLevel2Id] = useState(null);
//   const [savedLevel3Id, setSavedLevel3Id] = useState(null);

//   const [folderName,       setFolderName]       = useState("");
//   const [folderLevelData,  setFolderLevelData]  = useState([]);
//   const [folderPickerOpen, setFolderPickerOpen] = useState(false);
//   const [expandedLevel1,   setExpandedLevel1]   = useState(null);
//   const [expandedLevel2,   setExpandedLevel2]   = useState(null);
//   const [folderSearchText, setFolderSearchText] = useState("");
//   const folderPickerRef   = useRef(null);
//   const folderDropdownRef = useRef(null);

//   const [coursePlans,     setCoursePlans]     = useState([]);
//   const [selectedPlanIds, setSelectedPlanIds] = useState([]);

//   const [markingSchemeFromAPI,   setMarkingSchemeFromAPI]   = useState([]);
//   const [selectedMarkingSchemes, setSelectedMarkingSchemes] = useState({});

//   const [detailsVisible,       setDetailsVisible]       = useState(true);
//   const [coursePlansVisible,   setCoursePlansVisible]   = useState(true);
//   const [markingSchemeVisible, setMarkingSchemeVisible] = useState(true);
//   const [showCancelModal,      setShowCancelModal]      = useState(false);

//   // ── PREVIEW state ──────────────────────────────────────────────────────────
//   const [previewData,           setPreviewData]           = useState(null);
//   const [previewLoading,        setPreviewLoading]        = useState(false);
//   const [showPreviewPopup,      setShowPreviewPopup]      = useState(false);
//   const [showOptions,           setShowOptions]           = useState(false);
//   const [showSetModal,          setShowSetModal]          = useState(false);
//   const [selectedSetForPreview, setSelectedSetForPreview] = useState("A");

//   // ═══════════════════════════════════════════════════════════════════════════
//   //  DATA FETCHING
//   // ═══════════════════════════════════════════════════════════════════════════

//   useEffect(() => {
//     if (!quesPaperIdParam) return;
//     GET.withToken(
//       `${EndPoints.PRISM_GET_TEST_SCHEDULE_BY_QUES_PAPER_ID}?ques_paper_id=${quesPaperIdParam}`,
//       { setMessageBox, setIsMessageBoxVisible, setActiveImg, ErrorImg }
//     ).then((response) => {
//       const row = response?.data?.[0];
//       if (!row) return;
//       const plans = Array.isArray(row.course_plans) ? row.course_plans : [];
//       setSelectedPlanIds(plans.map((p) => p.course_plan_id));
//       setScheduleStatus(row.status ?? 1);
//       setSavedLevel1Id(row.test_level1_id ?? null);
//       setSavedLevel2Id(row.test_level2_id ?? null);
//       setSavedLevel3Id(row.test_level3_id ?? null);
//       const parts = [row.test_level1_name, row.test_level2_name, row.test_level3_name].filter(Boolean);
//       setFolderName(parts.join(" > "));
//     }).catch((e) => console.error("schedule by ques paper:", e));
//   }, [quesPaperIdParam]);

//   useEffect(() => {
//     if (!quesPaperIdParam) return;
//     GET.withToken(
//       `${EndPoints.PRISM_GET_TEST_SCHEDULE_DETAILS_BY_ID}?ques_paper_id=${quesPaperIdParam}`,
//       { setMessageBox, setIsMessageBoxVisible, setActiveImg, ErrorImg }
//     ).then((response) => {
//       const data = response?.data;
//       if (!data) return;

//       setTestScheduleId(data.test_schedule_id);
//       setSelectedTestSeriesId(data.ts_id);

//       setQuesPaperName(data.ques_paper_name        || "");
//       setQuesPaperDescription(data.ques_paper_desc || "");
//       setQuesPaperCreatedBy(data.ques_paper_created_by || "");

//       if (Array.isArray(data.subject_superset_id_list)) {
//         const unique = data.subject_superset_id_list.filter((s, i, arr) =>
//           arr.findIndex((x) => x.subject_superset_id === s.subject_superset_id) === i
//         );
//         setTestSeriesSubjects(unique.map((s) => s.subject_superset_name).join(", "));
//       }

//       setTestName(data.test_name          || "");
//       setTestDescription(data.test_desc   || "");
//       setTestWindowStart(toDatetimeLocal(data.test_window_start));
//       setTestWindowEnd(toDatetimeLocal(data.test_window_end));
//       setDuration(data.duration           || "");
//       setNumberOfSets(data.no_of_sets     || 1);
//       setShuffleSubjects(!!data.shuffle_subjects);
//       setShuffleQuestions(!!data.shuffle_questions);
//       setShuffleOptions(!!data.shuffle_options);
//       setInstructionsHtml(data.instructions_html || "");

//       if (Array.isArray(data.marking_scheme)) {
//         setMarkingSchemeFromAPI(data.marking_scheme);
//         const prefilled = {};
//         data.marking_scheme.forEach((entry) => {
//           const id = entry.subject_superset_id;
//           ["a", "b", "c", "d"].forEach((char, idx) => {
//             const val = entry[`ms_id_sec_${char}`];
//             if (val != null) prefilled[`${id}-${idx}`] = val;
//           });
//         });
//         setSelectedMarkingSchemes(prefilled);
//       }
//     }).catch((e) => console.error("schedule details:", e));
//   }, [quesPaperIdParam]);

//   useEffect(() => {
//     GET.withToken(EndPoints.PRISM_GET_COURSES)
//       .then((d) => { if (Array.isArray(d)) setCourses(d); })
//       .catch((e) => console.error("courses:", e));
//   }, []);

//   useEffect(() => {
//     if (!clientBranchId) return;
//     GET.withToken(`${EndPoints.PRISM_GET_TEST_SERIES_LIST_BY_BRANCH}?client_branch_id=${clientBranchId}`)
//       .then((r) => { if (r?.status === 200 && Array.isArray(r.data)) setAllTestSeries(r.data); })
//       .catch((e) => console.error("test series:", e));
//   }, [clientBranchId]);

//   useEffect(() => {
//     GET.withToken(EndPoints.PRISM_GET_MARKING_SCHEME_LIST)
//       .then((r) => { if (r?.status_code === 200 || r?.status === "success") setMarkingSchemeList(r.data); })
//       .catch((e) => console.error("marking schemes:", e));
//   }, []);

//   useEffect(() => {
//     if (!userName || !clientBranchId) return;
//     GET.withToken(`${EndPoints.PRISM_GET_TEST_INSTRUCTIONS_TEMPLATE_LIST_V1}?username=${userName}&branch_id=${clientBranchId}`)
//       .then((d) => { if (Array.isArray(d)) setTestTemplates(d); })
//       .catch((e) => console.error("templates:", e));
//   }, [userName, clientBranchId]);

//   useEffect(() => {
//     if (!selectedTestSeriesId || !allTestSeries.length) return;
//     const series = allTestSeries.find((ts) => ts.ts_id === Number(selectedTestSeriesId));
//     if (!series) return;
//     setSelectedTestSeriesObj(series);
//     setTestSeriesDescription(series.ts_desc || "");
//     const course = courses.find((c) => c.course_id === series.course_id);
//     if (course) setCourseOpted({ id: course.course_id, label: course.course_name });
//   }, [selectedTestSeriesId, allTestSeries, courses]);

//   useEffect(() => {
//     if (!courseOpted) { setCoursePlans([]); return; }
//     const courseId = typeof courseOpted === "object" ? courseOpted.id : courseOpted;
//     GET.withToken(`${EndPoints.PRISM_GET_COURSE_PLAN}?course_id=${courseId}`)
//       .then((r) => {
//         if (r?.status === 200 && Array.isArray(r.data)) setCoursePlans(r.data);
//         else setCoursePlans([]);
//       })
//       .catch((e) => { console.error("course plans:", e); setCoursePlans([]); });
//   }, [courseOpted]);

//   useEffect(() => {
//     if (!coursePlans.length) { setFolderLevelData([]); return; }
//     const planId = coursePlans[0].course_plan_id;
//     const url = `${EndPoints.PRISM_GET_TEST_FOLDER_STRUCTURE}?course_plan_id=${planId}`;
//     GET.withToken(url)
//       .then((r) => { if (r?.status === 200 && Array.isArray(r.data)) setFolderLevelData(r.data); })
//       .catch((e) => console.error("folder levels:", e));
//   }, [coursePlans]);

//   useEffect(() => {
//     const handler = (e) => {
//       if (
//         folderPickerOpen &&
//         folderPickerRef.current && !folderPickerRef.current.contains(e.target) &&
//         (!folderDropdownRef.current || !folderDropdownRef.current.contains(e.target))
//       ) {
//         setFolderPickerOpen(false);
//         setExpandedLevel1(null); setExpandedLevel2(null);
//         setFolderSearchText("");
//       }
//     };
//     document.addEventListener("mousedown", handler);
//     return () => document.removeEventListener("mousedown", handler);
//   }, [folderPickerOpen]);

//   // ═══════════════════════════════════════════════════════════════════════════
//   //  HANDLERS
//   // ═══════════════════════════════════════════════════════════════════════════

//   const handleMarkingSchemeChange = (supersetId, sectionIdx, value) => {
//     const changedKey = `${supersetId}-${sectionIdx}`;
//     setSelectedMarkingSchemes((prev) => {
//       const updated = { ...prev, [changedKey]: value };
//       markingSchemeFromAPI.forEach((entry) => {
//         const id = entry.subject_superset_id;
//         ["a", "b", "c", "d"].forEach((_, idx) => {
//           const k = `${id}-${idx}`;
//           if (k !== changedKey && updated[k] == null) updated[k] = value;
//         });
//       });
//       return updated;
//     });
//   };

//   const handleSave = async () => {
//     if (!testScheduleId) {
//       setMessageBox(<div className="Container-messageBOX"><div className="messagebox-insider1"><span>Schedule not loaded yet.</span></div></div>);
//       setIsMessageBoxVisible(true); setActiveImg(ErrorImg); return;
//     }
//     if (!testName.trim()) {
//       setMessageBox(<div className="Container-messageBOX"><div className="messagebox-insider1"><span>Test Name is required.</span></div></div>);
//       setIsMessageBoxVisible(true); setActiveImg(ErrorImg); return;
//     }
//     if (!testWindowStart || !testWindowEnd) {
//       setMessageBox(<div className="Container-messageBOX"><div className="messagebox-insider1"><span>Test Window Start and End are required.</span></div></div>);
//       setIsMessageBoxVisible(true); setActiveImg(ErrorImg); return;
//     }
//     if (!duration) {
//       setMessageBox(<div className="Container-messageBOX"><div className="messagebox-insider1"><span>Duration is required.</span></div></div>);
//       setIsMessageBoxVisible(true); setActiveImg(ErrorImg); return;
//     }

//     const subjectsPayload = markingSchemeFromAPI.map((entry) => {
//       const id = entry.subject_superset_id;
//       return {
//         subject_superset_id: id,
//         marking_scheme: [{
//           ms_id_sec_a: selectedMarkingSchemes?.[`${id}-0`] ?? entry.ms_id_sec_a ?? null,
//           ms_id_sec_b: entry.ms_id_sec_b != null ? (selectedMarkingSchemes?.[`${id}-1`] ?? entry.ms_id_sec_b) : null,
//           ms_id_sec_c: entry.ms_id_sec_c != null ? (selectedMarkingSchemes?.[`${id}-2`] ?? entry.ms_id_sec_c) : null,
//           ms_id_sec_d: entry.ms_id_sec_d != null ? (selectedMarkingSchemes?.[`${id}-3`] ?? entry.ms_id_sec_d) : null,
//         }],
//       };
//     });

//     const payload = {
//       ts_id:             selectedTestSeriesId,
//       ques_paper_id:     Number(quesPaperIdParam),
//       test_name:         testName.trim(),
//       test_desc:         testDescription.trim() || testName.trim(),
//       test_window_start: testWindowStart,
//       test_window_end:   testWindowEnd,
//       duration_mins:     parseInt(duration) || 0,
//       no_of_sets:        numberOfSets || 1,
//       status:            scheduleStatus,
//       instructions_html: instructionsHtml || null,
//       test_level1_id:    savedLevel1Id,
//       test_level2_id:    savedLevel2Id,
//       test_level3_id:    savedLevel3Id,
//       cancel_reason:     null,
//       test_term_date:    null,
//       shuffle_subjects:  isAITS ? shuffleSubjects  : false,
//       shuffle_questions: isAITS ? shuffleQuestions : false,
//       shuffle_options:   isAITS ? shuffleOptions   : false,
//       username:          userName || "",
//       subjects:          subjectsPayload,
//       course_plan_ids:     selectedPlanIds,
//     };

//     try {
//       const result = await PUT.withToken(
//         `${EndPoints.PRISM_UPDATE_TEST_SCHEDULE}?ques_paper_id=${quesPaperIdParam}`,
//         payload,
//         { setMessageBox, setIsMessageBoxVisible, setActiveImg, ErrorImg }
//       );
//       if (result?.status === 200) {
//         setMessageBox(<div className="Container-messageBOX"><div className="messagebox-insider1"><span>{result.message || "Test schedule updated successfully!"}</span></div></div>);
//         setIsMessageBoxVisible(true); setActiveImg(SuccessImg);
//         setTimeout(() => navigate(-1), 1000);
//       }
//     } catch (e) { console.error("Error updating:", e); }
//   };

//   const handleCancelTestSchedule = async (comment) => {
//     const payload = { username: userName, test_schedule_id: Number(testScheduleId), comment };
//     try {
//       const response = await PUT.withToken(
//         EndPoints.PRISM_CANCEL_TEST_SCHEDULE,
//         payload,
//         { setMessageBox, setIsMessageBoxVisible, setActiveImg, ErrorImg }
//       );
//       setShowCancelModal(false);
//       const success = response?.status === 200;
//       setMessageBox(
//         <div className="Container-messageBOX">
//           <div className="messagebox-insider1">
//             <span>{success ? "Test schedule cancelled successfully." : (response?.message || "An error occurred.")}</span>
//           </div>
//         </div>
//       );
//       setActiveImg(success ? SuccessImg : ErrorImg);
//       setIsMessageBoxVisible(true);
//       if (success) setTimeout(() => { setIsMessageBoxVisible(false); navigate(-1); }, 1500);
//     } catch (err) {
//       setMessageBox(<div className="Container-messageBOX"><span>Unexpected error: {err.message}</span></div>);
//       setActiveImg(ErrorImg); setIsMessageBoxVisible(true);
//     }
//   };

//   // ── PREVIEW handlers ───────────────────────────────────────────────────────

//   const handlePreviewClick = () => {
//     if ((numberOfSets || 1) > 1) {
//       setSelectedSetForPreview("A");
//       setShowSetModal(true);
//     } else {
//       handlePreview(null); // no_of_sets == 1: don't send set_names
//     }
//   };

//   const handlePreview = async (setName) => {
//     if (!quesPaperIdParam) return;
//     // When no_of_sets == 1, omit set_names param entirely
//     const previewUrl = setName
//       ? `${EndPoints.PRISM_GET_FULL_QUESTION_PAPER_FOR_TEST_BY_QUES_PAPER_AND_SET}?ques_paper_id=${quesPaperIdParam}&set_names=${encodeURIComponent(setName)}`
//       : `${EndPoints.PRISM_GET_FULL_QUESTION_PAPER_FOR_TEST_BY_QUES_PAPER_AND_SET}?ques_paper_id=${quesPaperIdParam}`;

//     setPreviewLoading(true);
//     try {
//       const result = await GET.withToken(previewUrl, { setMessageBox, setIsMessageBoxVisible, setActiveImg, ErrorImg });
//       if (result?.status === 200) {
//         setPreviewData({
//           ques_paper_info: result.ques_paper_info,
//           sets: result.sets,
//         });
//         setShowPreviewPopup(true);
//       } else {
//         setMessageBox(<div className="Container-messageBOX"><div className="messagebox-insider1"><span>{result?.message || "Failed to load preview."}</span></div></div>);
//         setIsMessageBoxVisible(true); setActiveImg(ErrorImg);
//       }
//     } catch (e) {
//       console.error("Preview error:", e);
//     } finally {
//       setPreviewLoading(false);
//     }
//   };

//   // ═══════════════════════════════════════════════════════════════════════════
//   //  RENDER
//   // ═══════════════════════════════════════════════════════════════════════════

//   const inputStyle = {
//     width: "100%", padding: "8px 10px",
//     border: "1px solid var(--DppInputBorder, #d0d0d0)",
//     borderRadius: "0px",
//     fontSize: "14px", boxSizing: "border-box",
//     backgroundColor: "var(--DppInputBackground, #fff)",
//     color: "var(--Gray-2, #6A6A6A)",
//   };
//   const disabledStyle = {
//     ...inputStyle,
//     opacity: 0.55, cursor: "not-allowed",
//     backgroundColor: "var(--DppDropdownBackground, #f5f5f5)",
//   };
//   const labelStyle = { fontSize: "14px", color: "var(--DppLabelText, #6A6A6A)", display: "block", marginBottom: "5px" };

//   const SectionHeader = ({ title, visible, onToggle }) => (
//     <div className="Header-1-C424342" style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "5px" }}>
//       <span>{title}</span>
//       {visible
//         ? <img src={MinusImg} alt="collapse" style={{ cursor: "pointer", width: "24px", height: "10px" }} onClick={onToggle} />
//         : <div className="plus" style={{ cursor: "pointer", fontSize: "28px", width: "24px", height: "24px", display: "flex", alignItems: "center", justifyContent: "center", color: "var(--Gray-2, #6A6A6A)", fontWeight: "bold" }} onClick={onToggle}>+</div>
//       }
//     </div>
//   );

//   return (
//     <>
//       <div className="Leftmargin-Main-DIV">

//         {/* ── top bar ── */}
//         <div style={{ position: "sticky", top: 0, backgroundColor: "white", zIndex: 100 }}>
//           <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: "20px", width: "98%" }}>
//             <div style={{ fontSize: "30px", color: `${Colors.color1}`, fontWeight: "400", whiteSpace: "nowrap" }}>
//               Test Scheduling
//             </div>
//             <div>
//               <div className="row-cs-uni">
//                 <button className="create-test-section-btn" style={{ marginRight: "18px", boxShadow: "0px 4px 4px 0px #00000040" }} onClick={() => navigate(-1)}>
//                   CANCEL
//                 </button>
//                 {!isCancelled && (
//                   <button className="create-test-section-btn" style={{ marginRight: "18px" }} onClick={() => setShowCancelModal(true)}>
//                     DELETE
//                   </button>
//                 )}
//                 <button
//                   className="create-test-section-btn"
//                   style={{ marginRight: "18px", boxShadow: "0px 4px 4px 0px #00000040", cursor: isCancelled ? "not-allowed" : "pointer", opacity: isCancelled ? 0.6 : 1 }}
//                   onClick={!isCancelled ? handleSave : undefined}
//                   disabled={isCancelled}
//                 >
//                   SAVE
//                 </button>
//                 <button
//                   className="create-test-section-btn"
//                   style={{ marginRight: "0px", opacity: previewLoading ? 0.6 : 1, cursor: previewLoading ? "wait" : "pointer" }}
//                   onClick={!previewLoading ? handlePreviewClick : undefined}
//                   disabled={previewLoading}
//                 >
//                   {previewLoading ? "LOADING..." : "PREVIEW"}
//                 </button>
//               </div>
//             </div>
//           </div>
//         </div>

//         <SectionHeader title="TEST DETAILS" visible={detailsVisible} onToggle={() => setDetailsVisible((v) => !v)} />

//         {detailsVisible && (
//           <div className="Body-1-C424342" style={{ paddingBottom: 16 }}>
//             <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", columnGap: "24px", rowGap: "8px", paddingRight: "5.5px" }}>

//               <div>
//                 <ReflectDropdown label="Test Series" style={{ width: "100%" }}
//                   setSelected={() => {}} selected={selectedTestSeriesId}
//                   options={[{ label: "-None-", id: 0 }, ...allTestSeries.map((ts) => ({ label: `${ts.ts_name} - ${ts.course_name || ""}`, id: ts.ts_id }))]}
//                   isRequired={false} isDisabled={true}
//                 />
//               </div>
//               <div>
//                 <InputComponent label="Description" style={{ width: "100%" }} value={testSeriesDescription} isRequired={false} disable={true} />
//               </div>
//               <div>
//                 <DropDown3 label="Course" style={{ width: "100%" }} setSelected={() => {}} selected={courseOpted}
//                   options={courses.map((c) => ({ label: c.course_name, id: c.course_id }))} isRequired={false} disabled={true} />
//               </div>

//               <div>
//                 <InputComponent label="Question Paper Name" style={{ width: "100%" }} value={quesPaperName} isRequired={false} disable={true} />
//               </div>
//               <div>
//                 <InputComponent label="Question Paper Description" style={{ width: "100%" }} value={quesPaperDescription} isRequired={false} disable={true} />
//               </div>
//               <div>
//                 <InputComponent label="Subjects" style={{ width: "100%" }} value={testSeriesSubjects} isRequired={false} disable={true} icon={introgativeImgBlue} />
//               </div>

//               <div>
//                 <InputComponent label="Question Paper Created By" style={{ width: "100%" }} value={quesPaperCreatedBy} isRequired={false} disable={true} />
//               </div>
//               <div>
//                 <label style={labelStyle}>Test Name <span style={{ color: "red" }}>*</span></label>
//                 <input type="text" style={isCancelled ? disabledStyle : inputStyle} value={testName}
//                   placeholder="Enter test name" disabled={isCancelled} onChange={(e) => setTestName(e.target.value)} />
//               </div>
//               <div>
//                 <label style={labelStyle}>Description</label>
//                 <input type="text" style={isCancelled ? disabledStyle : inputStyle} value={testDescription}
//                   placeholder="Enter description" disabled={isCancelled} onChange={(e) => setTestDescription(e.target.value)} />
//               </div>

//               <div>
//                 <label style={labelStyle}>Test Window Start <span style={{ color: "red" }}>*</span></label>
//                 <input type="datetime-local" style={isCancelled ? disabledStyle : inputStyle}
//                   value={testWindowStart} disabled={isCancelled} onChange={(e) => setTestWindowStart(e.target.value)} />
//               </div>
//               <div>
//                 <label style={labelStyle}>Test Window End <span style={{ color: "red" }}>*</span></label>
//                 <input type="datetime-local" style={isCancelled ? disabledStyle : inputStyle}
//                   min={testWindowStart || getCurrentDateTime()} value={testWindowEnd} disabled={isCancelled}
//                   onChange={(e) => setTestWindowEnd(e.target.value)} />
//               </div>
//               <div style={{ position: "relative" }}>
//                 <label style={labelStyle}>
//                   Folder Name {!isAITS && <span style={{ color: "red" }}>*</span>}
//                 </label>
//                 <div ref={folderPickerRef} style={{ position: "relative" }}>
//                   <input
//                     type="text"
//                     style={!isCancelled && !isAITS ? { ...inputStyle, paddingRight: "30px" } : { ...disabledStyle, paddingRight: "30px" }}
//                     value={folderPickerOpen ? folderSearchText : folderName}
//                     placeholder="Select or search folder..."
//                     disabled={isCancelled || isAITS}
//                     onChange={(e) => {
//                       setFolderSearchText(e.target.value);
//                       setExpandedLevel1(null); setExpandedLevel2(null);
//                       if (!folderPickerOpen) setFolderPickerOpen(true);
//                     }}
//                     onFocus={() => { if (!isCancelled && !isAITS) { setFolderPickerOpen(true); setFolderSearchText(""); } }}
//                   />
//                   <span
//                     onClick={() => { if (!isCancelled && !isAITS) { setFolderPickerOpen((v) => !v); setFolderSearchText(""); setExpandedLevel1(null); setExpandedLevel2(null); } }}
//                     style={{ position: "absolute", right: "10px", top: "50%", transform: "translateY(-50%)", color: "var(--Gray-2, #6A6A6A)", cursor: "pointer", fontSize: "11px" }}
//                   >▼</span>
//                 </div>

//                 {folderPickerOpen && !isAITS && !isCancelled && (
//                   <div ref={folderDropdownRef} style={{ position: "absolute", top: "100%", left: 0, zIndex: 9999, marginTop: "2px", minWidth: "220px" }}>
//                     {folderSearchText.trim() ? (
//                       <div style={{ backgroundColor: "var(--DppInputBackground, #fff)", border: "1px solid var(--DppInputBorder, #ddd)", borderRadius: "0px", boxShadow: "0 4px 12px rgba(0,0,0,0.15)", maxHeight: "220px", overflowY: "auto", width: "360px" }}>
//                         {(() => {
//                           const term = folderSearchText.toLowerCase();
//                           const results = [];
//                           folderLevelData.forEach((l1) => {
//                             (l1.level2 || []).forEach((l2) => {
//                               const path2 = `${l1.name || "Level 1"} > ${l2.name || "Level 2"}`;
//                               if ((l2.name || "").toLowerCase().includes(term)) results.push({ path: path2, l1Id: l1.test_level1_id, l2Id: l2.test_level2_id, l3Id: null });
//                               (l2.level3 || []).forEach((l3) => {
//                                 const path3 = `${path2} > ${l3.name || "Level 3"}`;
//                                 if ((l3.name || "").toLowerCase().includes(term)) results.push({ path: path3, l1Id: l1.test_level1_id, l2Id: l2.test_level2_id, l3Id: l3.test_level3_id });
//                               });
//                             });
//                           });
//                           if (!results.length) return <div style={{ padding: "12px", color: "var(--Gray-2, #6A6A6A)", fontSize: "14px", textAlign: "center" }}>No results found</div>;
//                           return results.map((r, i) => (
//                             <div key={i}
//                               onClick={() => { setFolderName(r.path); setSavedLevel1Id(r.l1Id); setSavedLevel2Id(r.l2Id); setSavedLevel3Id(r.l3Id); setFolderPickerOpen(false); setFolderSearchText(""); }}
//                               style={{ padding: "8px 12px", cursor: "pointer", borderBottom: "1px solid var(--DppDropdownItemBorder, #f0f0f0)", fontSize: "14px", color: "var(--Gray-2, #6A6A6A)" }}
//                               onMouseEnter={(e) => e.currentTarget.style.backgroundColor = "var(--DppDropdownHoverBackground, #f0f7ff)"}
//                               onMouseLeave={(e) => e.currentTarget.style.backgroundColor = "var(--DppInputBackground, #fff)"}>
//                               {r.path}
//                             </div>
//                           ));
//                         })()}
//                       </div>
//                     ) : (
//                       <div style={{ display: "flex", alignItems: "flex-start" }}>
//                         <div style={{ backgroundColor: "var(--DppInputBackground, #fff)", border: "1px solid var(--DppInputBorder, #ddd)", borderRadius: "0px", boxShadow: "0 4px 12px rgba(0,0,0,0.15)", width: "170px", maxHeight: "220px", overflowY: "auto" }}>
//                           {folderLevelData.length === 0
//                             ? <div style={{ padding: "12px", color: "var(--Gray-2, #6A6A6A)", fontSize: "14px" }}>No folders available</div>
//                             : folderLevelData.map((l1) => (
//                               <div key={l1.test_level1_id}
//                                 onMouseEnter={() => { setExpandedLevel1(l1.test_level1_id); setExpandedLevel2(null); }}
//                                 style={{ padding: "8px 10px", backgroundColor: expandedLevel1 === l1.test_level1_id ? "var(--DppDropdownHoverBackground, #f0f7ff)" : "var(--DppInputBackground, #fff)", cursor: "default", display: "flex", justifyContent: "space-between", alignItems: "center", borderBottom: "1px solid var(--DppDropdownItemBorder, #f0f0f0)", fontSize: "14px", color: "var(--Gray-2, #6A6A6A)", fontWeight: "500" }}>
//                                 <span style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{l1.name || "(No name)"}</span>
//                                 {(l1.level2 || []).length > 0 && <span style={{ fontSize: "9px", color: "var(--Gray-2, #6A6A6A)", flexShrink: 0, marginLeft: "4px" }}>▶</span>}
//                               </div>
//                             ))
//                           }
//                         </div>

//                         {expandedLevel1 && (() => {
//                           const l1 = folderLevelData.find((x) => x.test_level1_id === expandedLevel1);
//                           if (!l1?.level2?.length) return null;
//                           return (
//                             <div style={{ backgroundColor: "var(--DppInputBackground, #fff)", border: "1px solid var(--DppInputBorder, #ddd)", borderRadius: "0px", boxShadow: "0 4px 12px rgba(0,0,0,0.15)", width: "170px", maxHeight: "220px", overflowY: "auto", marginLeft: "3px" }}>
//                               {l1.level2.map((l2) => (
//                                 <div key={l2.test_level2_id}
//                                   onMouseEnter={() => setExpandedLevel2(l2.test_level2_id)}
//                                   onClick={() => { const path = `${l1.name || "L1"} > ${l2.name || "L2"}`; setFolderName(path); setSavedLevel1Id(l1.test_level1_id); setSavedLevel2Id(l2.test_level2_id); setSavedLevel3Id(null); setFolderPickerOpen(false); setExpandedLevel1(null); setExpandedLevel2(null); }}
//                                   style={{ padding: "8px 10px", backgroundColor: expandedLevel2 === l2.test_level2_id ? "var(--DppDropdownHoverBackground, #f0f7ff)" : "var(--DppInputBackground, #fff)", cursor: "pointer", display: "flex", justifyContent: "space-between", alignItems: "center", borderBottom: "1px solid var(--DppDropdownItemBorder, #f0f0f0)", fontSize: "14px", color: "var(--Gray-2, #6A6A6A)" }}>
//                                   <span style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{l2.name || "(No name)"}</span>
//                                   {(l2.level3 || []).length > 0 && <span style={{ fontSize: "9px", color: "var(--Gray-2, #6A6A6A)", flexShrink: 0, marginLeft: "4px" }}>▶</span>}
//                                 </div>
//                               ))}
//                             </div>
//                           );
//                         })()}

//                         {expandedLevel2 && (() => {
//                           const l1 = folderLevelData.find((x) => x.test_level1_id === expandedLevel1);
//                           const l2 = l1?.level2?.find((x) => x.test_level2_id === expandedLevel2);
//                           if (!l2?.level3?.length) return null;
//                           return (
//                             <div style={{ backgroundColor: "var(--DppInputBackground, #fff)", border: "1px solid var(--DppInputBorder, #ddd)", borderRadius: "0px", boxShadow: "0 4px 12px rgba(0,0,0,0.15)", width: "170px", maxHeight: "220px", overflowY: "auto", marginLeft: "3px" }}>
//                               {l2.level3.map((l3) => (
//                                 <div key={l3.test_level3_id}
//                                   onClick={() => { const path = `${l1.name || "L1"} > ${l2.name || "L2"} > ${l3.name || "L3"}`; setFolderName(path); setSavedLevel1Id(l1.test_level1_id); setSavedLevel2Id(l2.test_level2_id); setSavedLevel3Id(l3.test_level3_id); setFolderPickerOpen(false); setExpandedLevel1(null); setExpandedLevel2(null); }}
//                                   style={{ padding: "8px 10px", cursor: "pointer", borderBottom: "1px solid var(--DppDropdownItemBorder, #f0f0f0)", fontSize: "14px", color: "var(--Gray-2, #6A6A6A)" }}
//                                   onMouseEnter={(e) => e.currentTarget.style.backgroundColor = "var(--DppDropdownHoverBackground, #f0f7ff)"}
//                                   onMouseLeave={(e) => e.currentTarget.style.backgroundColor = "var(--DppInputBackground, #fff)"}>
//                                   <span style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", display: "block" }}>{l3.name || "(No name)"}</span>
//                                 </div>
//                               ))}
//                             </div>
//                           );
//                         })()}
//                       </div>
//                     )}
//                   </div>
//                 )}
//               </div>

//               <div>
//                 <label style={labelStyle}>Duration (mins) <span style={{ color: "red" }}>*</span></label>
//                 <input type="number" style={isCancelled ? disabledStyle : inputStyle} value={duration}
//                   placeholder="In minutes" disabled={isCancelled} onChange={(e) => setDuration(e.target.value)} />
//               </div>
//               <div>
//                 <ReflectDropdown label="No. of Sets" style={{ width: "100%" }}
//                   options={[1,2,3,4,5,6].map((n) => ({ label: String(n), id: n }))}
//                   selected={numberOfSets}
//                   setSelected={(val) => setNumberOfSets(val)}
//                   isDisabled={isCancelled || !isAITS}
//                 />
//               </div>
//               <div>
//                 <ReflectDropdown label="Shuffle Subject" style={{ width: "100%" }}
//                   options={[{ label: "No", id: 0 }, { label: "Yes", id: 1 }]}
//                   selected={shuffleSubjects ? 1 : 0}
//                   setSelected={(val) => setShuffleSubjects(Boolean(val))}
//                   isDisabled={isCancelled || !isAITS}
//                 />
//               </div>

//               <div>
//                 <ReflectDropdown label="Shuffle Question" style={{ width: "100%" }}
//                   options={[{ label: "Yes", id: 1 }, { label: "No", id: 0 }]}
//                   selected={shuffleQuestions ? 1 : 0}
//                   setSelected={(val) => setShuffleQuestions(Boolean(val))}
//                   isDisabled={isCancelled || !isAITS}
//                 />
//               </div>
//               <div>
//                 <ReflectDropdown label="Shuffle Option" style={{ width: "100%" }}
//                   options={[{ label: "No", id: 0 }, { label: "Yes", id: 1 }]}
//                   selected={shuffleOptions ? 1 : 0}
//                   setSelected={(val) => setShuffleOptions(Boolean(val))}
//                   isDisabled={isCancelled || !isAITS}
//                 />
//               </div>
//               <div />

//               <div style={{ gridColumn: "1 / -1" }}>
//                 <TextEditor templates={testTemplates} value={instructionsHtml}
//                   setValue={isCancelled ? () => {} : setInstructionsHtml} />
//               </div>

//             </div>
//           </div>
//         )}

//         <div style={{ marginTop: "20px" }}>
//           <SectionHeader title="COURSE PLANS" visible={coursePlansVisible} onToggle={() => setCoursePlansVisible((v) => !v)} />

//           {coursePlansVisible && (
//             <div className="Body-1-C424342" style={{ paddingBottom: 16 }}>
//               <div style={{ paddingRight: "5.5px" }}>
//                 <CoursePlanTable
//                   coursePlans={coursePlans}
//                   selectedPlanIds={selectedPlanIds}
//                   setSelectedPlanIds={isCancelled ? () => {} : setSelectedPlanIds}
//                 />
//               </div>
//             </div>
//           )}
//         </div>

//         <div style={{ marginTop: "20px" }}>
//           <SectionHeader title="MARKING SCHEME" visible={markingSchemeVisible} onToggle={() => setMarkingSchemeVisible((v) => !v)} />

//           {markingSchemeVisible && (
//             <div className="Body-1-C424342" style={{ padding: "15px", color: `${Colors.color1}`, marginBottom: "10px" }}>
//               {markingSchemeFromAPI.length === 0 ? (
//                 <div style={{ color: "var(--Gray-2, #6A6A6A)", fontSize: "14px", padding: "8px 0" }}></div>
//               ) : (
//                 <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", columnGap: "24px", rowGap: "8px", paddingRight: "5.5px" }}>
//                   {markingSchemeFromAPI
//                     .slice()
//                     .sort((a, b) => (a.subject_superset_name || "").localeCompare(b.subject_superset_name || ""))
//                     .map((entry) => {
//                       const id   = entry.subject_superset_id;
//                       const name = entry.subject_superset_name || "";
//                       const sectionsToRender = ["a", "b", "c", "d"].filter((char, idx) => {
//                         return idx === 0 || entry[`ms_id_sec_${char}`] != null;
//                       });

//                       return sectionsToRender.map((char, idx) => {
//                         const stateKey   = `${id}-${idx}`;
//                         const selectedId = selectedMarkingSchemes?.[stateKey] ?? entry[`ms_id_sec_${char}`] ?? null;
//                         const scheme     = markingSchemeList.find((ms) => ms.ms_id === selectedId);
//                         const sectionLabel = char.toUpperCase();

//                         return (
//                           <React.Fragment key={`${id}-${char}`}>
//                             <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: "12px", minWidth: 0 }}>
//                               <span style={{ fontSize: "14px", color: "var(--Gray-2, #6A6A6A)", whiteSpace: "nowrap", flexShrink: 0 }}>
//                                 {name} - {sectionLabel}
//                               </span>
//                               <div style={{ width: "300px", flexShrink: 0 }}>
//                                 <ReflectDropdown
//                                   style={{ width: "100%" }}
//                                   options={markingSchemeList.map((ms) => ({ label: ms.ms_name, id: ms.ms_id }))}
//                                   selected={selectedId}
//                                   setSelected={(val) => handleMarkingSchemeChange(id, idx, val)}
//                                   isDisabled={isCancelled}
//                                 />
//                               </div>
//                             </div>
//                             <div style={{ display: "flex", alignItems: "center", fontSize: "14px", color: "var(--Gray-2, #6A6A6A)", minWidth: 0, overflow: "hidden" }}>
//                               <span style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
//                                 {scheme ? `${scheme.expression} ; ${scheme.ms_desc}` : "—"}
//                               </span>
//                             </div>
//                             <div />
//                           </React.Fragment>
//                         );
//                       });
//                     })}
//                 </div>
//               )}
//             </div>
//           )}
//         </div>

//         <div style={{ height: "80px" }} />
//       </div>

//       {/* ── Set Selection Modal (shown when no_of_sets > 1) ── */}
//       {showSetModal && (
//         <div
//           style={{ position: "fixed", top: 0, left: 0, right: 0, bottom: 0, backgroundColor: "rgba(0,0,0,0.7)", display: "flex", justifyContent: "center", alignItems: "center", zIndex: 9999 }}
//           onClick={() => setShowSetModal(false)}
//         >
//           <div
//             style={{ backgroundColor: "white", borderRadius: "12px", width: "90%", maxWidth: "500px", display: "flex", flexDirection: "column", boxShadow: "0 10px 40px rgba(0,0,0,0.3)", overflow: "hidden" }}
//             onClick={(e) => e.stopPropagation()}
//           >
//             <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "10px 18px", borderBottom: "1px solid #e0e0e0", backgroundColor: "#f8f9fa", borderTopLeftRadius: "12px", borderTopRightRadius: "12px" }}>
//               <h2 style={{ margin: 0, fontSize: "16px", fontWeight: "600", color: "#333" }}>Question Paper Print Preview</h2>
//               <button style={{ background: "none", border: "none", fontSize: "20px", cursor: "pointer", color: "#666", width: "32px", height: "32px" }} onClick={() => setShowSetModal(false)}>✕</button>
//             </div>
//             <div style={{ padding: "25px", backgroundColor: "#f8f9fa", border: "2px solid #e0e0e0", margin: "15px", borderRadius: "8px" }}>
//               <h3 style={{ margin: "0 0 15px 0", fontSize: "14px", fontWeight: "600", color: "#333" }}>Select Set</h3>
//               <div style={{ display: "flex", gap: "15px", flexWrap: "wrap" }}>
//                 {Array.from({ length: numberOfSets || 1 }, (_, i) => String.fromCharCode(65 + i)).map((set) => (
//                   <label key={set} style={{ display: "flex", alignItems: "center", gap: "8px", cursor: "pointer", fontSize: "14px", padding: "10px 16px", borderRadius: "6px", fontWeight: "500", minWidth: "70px", justifyContent: "center" }}>
//                     <input
//                       type="radio"
//                       name="previewSet"
//                       value={set}
//                       checked={selectedSetForPreview === set}
//                       onChange={(e) => setSelectedSetForPreview(e.target.value)}
//                       style={{ cursor: "pointer", width: "18px", height: "18px", accentColor: "#4CAF50" }}
//                     />
//                     <span style={{ userSelect: "none" }}>{set}</span>
//                   </label>
//                 ))}
//               </div>
//             </div>
//             <div style={{ display: "flex", justifyContent: "flex-end", marginRight: "15px", marginBottom: "10px" }}>
//               <button
//                 onClick={() => { setShowSetModal(false); handlePreview(selectedSetForPreview); }}
//                 style={{ padding: "12px 30px", fontSize: "14px", backgroundColor: "#fff", color: "#0b0b0bb9", border: "1px solid black", cursor: "pointer", borderRadius: "6px", fontWeight: "600", display: "flex", alignItems: "center", gap: "8px", boxShadow: "0 4px 4px rgba(46,45,45,0.3)" }}
//               >
//                 🖥️ PREVIEW
//               </button>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* ── Preview Popup ── */}
//       {showPreviewPopup && previewData && (
//         <div
//           style={{
//             position: "fixed", top: 0, left: 0, right: 0, bottom: 0,
//             backgroundColor: "rgba(0,0,0,0.5)", zIndex: 9999,
//             display: "flex", alignItems: "center", justifyContent: "center",
//           }}
//           onClick={() => setShowPreviewPopup(false)}
//         >
//           <button
//             onClick={(e) => { e.stopPropagation(); setShowPreviewPopup(false); }}
//             style={{
//               position: "absolute", top: "20px", right: "20px",
//               background: "var(--DppInputBackground, #fff)", border: "1px solid var(--DppInputBorder, #d0d0d0)", borderRadius: "50%",
//               width: "36px", height: "36px", fontSize: "20px", cursor: "pointer",
//               display: "flex", alignItems: "center", justifyContent: "center",
//               color: "#666", fontWeight: "bold", zIndex: 10000,
//             }}
//           >
//             ×
//           </button>

//           <div
//             onClick={(e) => e.stopPropagation()}
//             style={{
//               width: "60vw", height: "80vh", backgroundColor: "var(--DppInputBackground, #fff)",
//               borderRadius: "8px", display: "flex", flexDirection: "column",
//               overflow: "hidden", boxShadow: "0 8px 32px rgba(0,0,0,0.2)",
//             }}
//           >
//             <div style={{
//               position: "sticky", top: 0, backgroundColor: "var(--DppInputBackground, #fff)", zIndex: 2,
//               padding: "16px 20px", borderBottom: "1px solid var(--DppInputBorder, #d0d0d0)",
//             }}>
//               <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
//                 <h3 style={{ margin: 0, color: "var(--Gray-2, #6A6A6A)" }}>
//                   Preview Question Paper
//                   <span
//                     style={{ marginLeft: "10px", cursor: "pointer", fontSize: "12px", textDecoration: "underline" }}
//                     onClick={() => setShowOptions((prev) => !prev)}
//                   >
//                     {showOptions ? "Hide Options" : "Show Options"}
//                   </span>
//                 </h3>
//               </div>
//               <div style={{ display: "flex", justifyContent: "space-between", flexWrap: "wrap", marginTop: "10px", fontSize: "14px" }}>
//                 <div style={{ flex: "0 0 48%" }}>
//                   <p style={{ marginBottom: "8px" }}><span>Question Paper:</span> {previewData.ques_paper_info?.ques_paper_name || quesPaperName || "N/A"}</p>
//                   <p><span>Course:</span> {courseOpted?.label || "N/A"}</p>
//                 </div>
//                 <div style={{ flex: "0 0 48%" }}>
//                   <p style={{ marginBottom: "8px" }}><span>Test Name:</span> {testName || "N/A"}</p>
//                   <p><span>Subjects:</span> {testSeriesSubjects || "N/A"}</p>
//                 </div>
//               </div>
//             </div>

//             <div style={{ overflowY: "auto", padding: "20px", flex: 1 }}>
//               {previewData.sets?.map((set, setIdx) => (
//                 <div key={set.set_name || setIdx} style={{ marginBottom: "30px" }}>
//                   {(numberOfSets || 1) > 1 && (
//                     <h3 style={{ textAlign: "center", color: "var(--Gray-2, #6A6A6A)", marginBottom: "16px", borderBottom: "2px solid var(--DppSectionBorder, #eeeeee)", paddingBottom: "8px" }}>
//                       Set {set.set_name}
//                     </h3>
//                   )}

//                   {set.subjects?.map((subject, subjIdx) => (
//                     <div key={subject.subject_superset_id || subjIdx} style={{ marginBottom: "24px" }}>
//                       <h4 style={{ color: "var(--Gray-2, #6A6A6A)", marginBottom: "12px", padding: "8px 12px" }}>
//                         {subject.subject_superset_name || `Subject ${subjIdx + 1}`}
//                       </h4>

//                       {subject.sections?.map((section, secIdx) => (
//                         <div key={section.section_name || secIdx} style={{ marginBottom: "16px", paddingLeft: "12px" }}>
//                           <h5 style={{ color: "var(--Gray-2, #6A6A6A)", marginBottom: "16px" }}>
//                             Section {section.section_name}
//                           </h5>

//                           {section.questions?.length > 0 ? (
//                             <ul style={{ listStyle: "none", padding: 0 }}>
//                               {section.questions.map((ques, qIdx) => (
//                                 <li key={ques.ques_id || qIdx} style={{ marginBottom: "16px", paddingLeft: "8px" }}>
//                                   <div style={{ marginBottom: "4px", fontSize: "14px", color: "var(--Gray-2, #6A6A6A)" }}>
//                                     {qIdx + 1}.{" "}
//                                     {(() => {
//                                       const raw = ques.question_text || ques.ques_text || "";
//                                       const decoded = he.decode(raw);
//                                       const segments = decoded.split(/(imgsrc=[^\s]+)/g);
//                                       return segments.map((seg, i) => {
//                                         if (seg.startsWith("imgsrc=")) {
//                                           const url = seg.replace("imgsrc=", "");
//                                           return <img key={i} src={url} alt={`Q${qIdx + 1}`} style={{ maxHeight: "100px", width: "auto", margin: "5px", verticalAlign: "middle" }} />;
//                                         }
//                                         return <span key={i}><Latex>{seg}</Latex></span>;
//                                       });
//                                     })()}
//                                   </div>

//                                   {showOptions && ques.options?.length > 0 && (
//                                     <div style={{ display: "flex", gap: "20px", flexWrap: "wrap", paddingLeft: "20px", marginTop: "5px" }}>
//                                       {[0, 1].map((col) => (
//                                         <ul key={col} style={{ flex: "1 1 45%", paddingLeft: "20px", listStyleType: "disc" }}>
//                                           {ques.options
//                                             .filter((_, idx) => idx % 2 === col)
//                                             .map((option, idx) => {
//                                               const globalIndex = col + idx * 2;
//                                               return (
//                                                 <li key={option.option_id || globalIndex} style={{ padding: "4px 0", fontSize: "13px", color: "#555" }}>
//                                                   {String.fromCharCode(65 + globalIndex).toLowerCase()}.{" "}
//                                                   {(() => {
//                                                     const raw = option.option_text || "";
//                                                     const decoded = he.decode(raw);
//                                                     const segments = decoded.split(/(imgsrc=[^\s]+)/g);
//                                                     return segments.map((seg, i) => {
//                                                       if (seg.startsWith("imgsrc=")) {
//                                                         const url = seg.replace("imgsrc=", "");
//                                                         return <img key={i} src={url} alt="option" style={{ maxHeight: "80px", width: "auto", margin: "3px", verticalAlign: "middle" }} />;
//                                                       }
//                                                       return <span key={i}><Latex>{seg}</Latex></span>;
//                                                     });
//                                                   })()}
//                                                 </li>
//                                               );
//                                             })}
//                                         </ul>
//                                       ))}
//                                     </div>
//                                   )}
//                                 </li>
//                               ))}
//                             </ul>
//                           ) : (
//                             <p style={{ color: "var(--Gray-2, #6A6A6A)", fontSize: "14px" }}>No questions in this section.</p>
//                           )}
//                         </div>
//                       ))}
//                     </div>
//                   ))}
//                 </div>
//               ))}
//             </div>
//           </div>
//         </div>
//       )}

//       <RejectModal
//         isOpen={showCancelModal}
//         onClose={() => setShowCancelModal(false)}
//         onSubmit={handleCancelTestSchedule}
//         title="Cancel Test Schedule"
//         placeholder="Enter reason for cancelling the test schedule..."
//         setMessageBox={setMessageBox}
//         setIsMessageBoxVisible={setIsMessageBoxVisible}
//         setActiveImg={setActiveImg}
//         errorImg={ErrorImg}
//       />
//     </>
//   );
// };

// export default TestSchedulingClone;





















































import React, { useState, useEffect, useRef } from "react";
import "./testscheduling.css";
import DropDown3 from "./Drodpwon-Catch";
import InputComponent from "./Input-testscheduling";
import introgativeImgBlue from "../../../Assets/Images/CommanImages/IntrogativeBlue.png";
import TextEditor from "../../Landing/components/TextEditor";
import MinusImg from "../../../Assets/Images/CommanImages/MinusGrey.png";
import SuccessImg from "../../../Assets/Images/CommanImages/success.png";
import ErrorImg from "../../../Assets/Images/CommanImages/Error.png";
import WarnningIcon from "../../../Assets/Images/CommanImages/Warning.png";
import Colors from "../../../Constants/Colors";
import ReflectDropdown from "../../../Components/ReflectDropdown/ReflectDropdwon";
import { useNavigate, useSearchParams } from "react-router-dom";
import { PUT, GET } from "../../../Api/HttpsMethods";
import EndPoints from "../../../Api/Endpoints";
import RejectModal from "../../../Components/RejectModal/RejectModal";
import CoursePlanTable from "./CoursePlanTable";
// import PreviewQuesPaper from "../PreviewQuesPapers/PreviewQuesPaper";
import Latex from "react-latex";
import "katex/dist/katex.min.css";
import he from "he";

// ─── helpers ─────────────────────────────────────────────────────────────────
const getCurrentDateTime = () => {
  const n = new Date();
  return (
    [n.getFullYear(), String(n.getMonth() + 1).padStart(2, "0"), String(n.getDate()).padStart(2, "0")].join("-") +
    "T" +
    [String(n.getHours()).padStart(2, "0"), String(n.getMinutes()).padStart(2, "0")].join(":")
  );
};

const toDatetimeLocal = (val) => {
  if (!val) return "";
  const d = new Date(val);
  if (isNaN(d)) return "";
  return (
    [d.getFullYear(), String(d.getMonth() + 1).padStart(2, "0"), String(d.getDate()).padStart(2, "0")].join("-") +
    "T" +
    [String(d.getHours()).padStart(2, "0"), String(d.getMinutes()).padStart(2, "0")].join(":")
  );
};

// ─── component ───────────────────────────────────────────────────────────────
const TestSchedulingClone = ({
  dataClient,
  setMessageBox,
  setIsMessageBoxVisible,
  setActiveImg,
}) => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const quesPaperIdParam = searchParams.get("IDs");
  const isCancelled      = searchParams.get("isCancelled") === "true";
  useEffect(() => {
    if (dataClient) {
      const u = dataClient?.client_schema_name?.[6]?.[0];
      if (u?.user_name)        sessionStorage.setItem("user_name",      u.user_name);
      if (u?.client_branch_id) sessionStorage.setItem("clientBranchId", u.client_branch_id);
      if (u?.client_id)        sessionStorage.setItem("clientId",        u.client_id);
    }
  }, [dataClient]);

  const userName       = dataClient?.client_schema_name?.[6]?.[0]?.user_name       || sessionStorage.getItem("user_name")      || "";
  const clientBranchId = dataClient?.client_schema_name?.[6]?.[0]?.client_branch_id || sessionStorage.getItem("clientBranchId") || null;

  const [allTestSeries,     setAllTestSeries]     = useState([]);
  const [courses,           setCourses]           = useState([]);
  const [markingSchemeList, setMarkingSchemeList] = useState([]);
  const [testTemplates,     setTestTemplates]     = useState([]);

  const [selectedTestSeriesId,  setSelectedTestSeriesId]  = useState(null);
  const [selectedTestSeriesObj, setSelectedTestSeriesObj] = useState(null);
  const [testSeriesDescription, setTestSeriesDescription] = useState("");
  const [courseOpted,           setCourseOpted]           = useState("");
  const [quesPaperName,         setQuesPaperName]         = useState("");
  const [quesPaperDescription,  setQuesPaperDescription]  = useState("");
  const [quesPaperCreatedBy,    setQuesPaperCreatedBy]    = useState("");
  const [testSeriesSubjects,    setTestSeriesSubjects]    = useState("");

  const [testScheduleId, setTestScheduleId] = useState(null);
  const [scheduleStatus, setScheduleStatus] = useState(1);

  const isAITS = !!selectedTestSeriesObj?.ts_name?.toUpperCase().includes("AITS");

  const [testName,         setTestName]         = useState("");
  const [testDescription,  setTestDescription]  = useState("");
  const [testWindowStart,  setTestWindowStart]  = useState("");
  const [testWindowEnd,    setTestWindowEnd]    = useState("");
  const [duration,         setDuration]         = useState("");
  const [numberOfSets,     setNumberOfSets]     = useState(1);
  const [shuffleSubjects,  setShuffleSubjects]  = useState(false);
  const [shuffleQuestions, setShuffleQuestions] = useState(false);
  const [shuffleOptions,   setShuffleOptions]   = useState(false);
  const [instructionsHtml, setInstructionsHtml] = useState("");

  const [savedLevel1Id, setSavedLevel1Id] = useState(null);
  const [savedLevel2Id, setSavedLevel2Id] = useState(null);
  const [savedLevel3Id, setSavedLevel3Id] = useState(null);

  const [folderName,       setFolderName]       = useState("");
  const [folderLevelData,  setFolderLevelData]  = useState([]);
  const [folderPickerOpen, setFolderPickerOpen] = useState(false);
  const [expandedLevel1,   setExpandedLevel1]   = useState(null);
  const [expandedLevel2,   setExpandedLevel2]   = useState(null);
  const [folderSearchText, setFolderSearchText] = useState("");
  const folderPickerRef   = useRef(null);
  const folderDropdownRef = useRef(null);

  const [coursePlans,     setCoursePlans]     = useState([]);
  const [selectedPlanIds, setSelectedPlanIds] = useState([]);

  const [markingSchemeFromAPI,   setMarkingSchemeFromAPI]   = useState([]);
  const [selectedMarkingSchemes, setSelectedMarkingSchemes] = useState({});

  const [detailsVisible,       setDetailsVisible]       = useState(true);
  const [coursePlansVisible,   setCoursePlansVisible]   = useState(true);
  const [markingSchemeVisible, setMarkingSchemeVisible] = useState(true);
  const [showCancelModal,      setShowCancelModal]      = useState(false);

  // ── PREVIEW state ──────────────────────────────────────────────────────────
  const [previewData,           setPreviewData]           = useState(null);
  const [previewLoading,        setPreviewLoading]        = useState(false);
  const [showPreviewPopup,      setShowPreviewPopup]      = useState(false);
  const [showOptions,           setShowOptions]           = useState(false);
  const [showSetModal,          setShowSetModal]          = useState(false);
  const [selectedSetForPreview, setSelectedSetForPreview] = useState("A");

  // ═══════════════════════════════════════════════════════════════════════════
  //  DATA FETCHING
  // ═══════════════════════════════════════════════════════════════════════════

  useEffect(() => {
    if (!quesPaperIdParam) return;
    GET.withToken(
      `${EndPoints.PRISM_GET_TEST_SCHEDULE_BY_QUES_PAPER_ID}?ques_paper_id=${quesPaperIdParam}`,
      { setMessageBox, setIsMessageBoxVisible, setActiveImg, ErrorImg }
    ).then((response) => {
      const row = response?.data?.[0];
      if (!row) return;
      const plans = Array.isArray(row.course_plans) ? row.course_plans : [];
      setSelectedPlanIds(plans.map((p) => p.course_plan_id));
      setScheduleStatus(row.status ?? 1);
      setSavedLevel1Id(row.test_level1_id ?? null);
      setSavedLevel2Id(row.test_level2_id ?? null);
      setSavedLevel3Id(row.test_level3_id ?? null);
      const parts = [row.test_level1_name, row.test_level2_name, row.test_level3_name].filter(Boolean);
      setFolderName(parts.join(" > "));
    }).catch((e) => console.error("schedule by ques paper:", e));
  }, [quesPaperIdParam]);

  useEffect(() => {
    if (!quesPaperIdParam) return;
    GET.withToken(
      `${EndPoints.PRISM_GET_TEST_SCHEDULE_DETAILS_BY_ID}?ques_paper_id=${quesPaperIdParam}`,
      { setMessageBox, setIsMessageBoxVisible, setActiveImg, ErrorImg }
    ).then((response) => {
      const data = response?.data;
      if (!data) return;

      setTestScheduleId(data.test_schedule_id);
      setSelectedTestSeriesId(data.ts_id);

      setQuesPaperName(data.ques_paper_name        || "");
      setQuesPaperDescription(data.ques_paper_desc || "");
      setQuesPaperCreatedBy(data.ques_paper_created_by || "");

      if (Array.isArray(data.subject_superset_id_list)) {
        const unique = data.subject_superset_id_list.filter((s, i, arr) =>
          arr.findIndex((x) => x.subject_superset_id === s.subject_superset_id) === i
        );
        setTestSeriesSubjects(unique.map((s) => s.subject_superset_name).join(", "));
      }

      setTestName(data.test_name          || "");
      setTestDescription(data.test_desc   || "");
      setTestWindowStart(toDatetimeLocal(data.test_window_start));
      setTestWindowEnd(toDatetimeLocal(data.test_window_end));
      setDuration(data.duration           || "");
      setNumberOfSets(data.no_of_sets     || 1);
      setShuffleSubjects(!!data.shuffle_subjects);
      setShuffleQuestions(!!data.shuffle_questions);
      setShuffleOptions(!!data.shuffle_options);
      setInstructionsHtml(data.instructions_html || "");

      if (Array.isArray(data.marking_scheme)) {
        setMarkingSchemeFromAPI(data.marking_scheme);
        const prefilled = {};
        data.marking_scheme.forEach((entry) => {
          const id = entry.subject_superset_id;
          ["a", "b", "c", "d"].forEach((char, idx) => {
            const val = entry[`ms_id_sec_${char}`];
            if (val != null) prefilled[`${id}-${idx}`] = val;
          });
        });
        setSelectedMarkingSchemes(prefilled);
      }
    }).catch((e) => console.error("schedule details:", e));
  }, [quesPaperIdParam]);

  useEffect(() => {
    GET.withToken(EndPoints.PRISM_GET_COURSES)
      .then((d) => { if (Array.isArray(d)) setCourses(d); })
      .catch((e) => console.error("courses:", e));
  }, []);

  useEffect(() => {
    if (!clientBranchId) return;
    GET.withToken(`${EndPoints.PRISM_GET_TEST_SERIES_LIST_BY_BRANCH}?client_branch_id=${clientBranchId}`)
      .then((r) => { if (r?.status === 200 && Array.isArray(r.data)) setAllTestSeries(r.data); })
      .catch((e) => console.error("test series:", e));
  }, [clientBranchId]);

  useEffect(() => {
    GET.withToken(EndPoints.PRISM_GET_MARKING_SCHEME_LIST)
      .then((r) => { if (r?.status_code === 200 || r?.status === "success") setMarkingSchemeList(r.data); })
      .catch((e) => console.error("marking schemes:", e));
  }, []);

  useEffect(() => {
    if (!userName || !clientBranchId) return;
    GET.withToken(`${EndPoints.PRISM_GET_TEST_INSTRUCTIONS_TEMPLATE_LIST_V1}?username=${userName}&branch_id=${clientBranchId}`)
      .then((d) => { if (Array.isArray(d)) setTestTemplates(d); })
      .catch((e) => console.error("templates:", e));
  }, [userName, clientBranchId]);

  useEffect(() => {
    if (!selectedTestSeriesId || !allTestSeries.length) return;
    const series = allTestSeries.find((ts) => ts.ts_id === Number(selectedTestSeriesId));
    if (!series) return;
    setSelectedTestSeriesObj(series);
    setTestSeriesDescription(series.ts_desc || "");
    const course = courses.find((c) => c.course_id === series.course_id);
    if (course) setCourseOpted({ id: course.course_id, label: course.course_name });
  }, [selectedTestSeriesId, allTestSeries, courses]);

  useEffect(() => {
    if (!courseOpted) { setCoursePlans([]); return; }
    const courseId = typeof courseOpted === "object" ? courseOpted.id : courseOpted;
    GET.withToken(`${EndPoints.PRISM_GET_COURSE_PLAN}?course_id=${courseId}`)
      .then((r) => {
        if (r?.status === 200 && Array.isArray(r.data)) setCoursePlans(r.data);
        else setCoursePlans([]);
      })
      .catch((e) => { console.error("course plans:", e); setCoursePlans([]); });
  }, [courseOpted]);

  useEffect(() => {
    if (!coursePlans.length) { setFolderLevelData([]); return; }
    const planId = coursePlans[0].course_plan_id;
    const url = `${EndPoints.PRISM_GET_TEST_FOLDER_STRUCTURE}?course_plan_id=${planId}`;
    GET.withToken(url)
      .then((r) => { if (r?.status === 200 && Array.isArray(r.data)) setFolderLevelData(r.data); })
      .catch((e) => console.error("folder levels:", e));
  }, [coursePlans]);

  useEffect(() => {
    const handler = (e) => {
      if (
        folderPickerOpen &&
        folderPickerRef.current && !folderPickerRef.current.contains(e.target) &&
        (!folderDropdownRef.current || !folderDropdownRef.current.contains(e.target))
      ) {
        setFolderPickerOpen(false);
        setExpandedLevel1(null); setExpandedLevel2(null);
        setFolderSearchText("");
      }
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, [folderPickerOpen]);

  // ═══════════════════════════════════════════════════════════════════════════
  //  HANDLERS
  // ═══════════════════════════════════════════════════════════════════════════

  const handleMarkingSchemeChange = (supersetId, sectionIdx, value) => {
    const changedKey = `${supersetId}-${sectionIdx}`;
    setSelectedMarkingSchemes((prev) => {
      const updated = { ...prev, [changedKey]: value };
      markingSchemeFromAPI.forEach((entry) => {
        const id = entry.subject_superset_id;
        ["a", "b", "c", "d"].forEach((_, idx) => {
          const k = `${id}-${idx}`;
          if (k !== changedKey && updated[k] == null) updated[k] = value;
        });
      });
      return updated;
    });
  };

  const handleSave = async () => {
    if (!testScheduleId) {
      setMessageBox(<div className="Container-messageBOX"><div className="messagebox-insider1"><span>Schedule not loaded yet.</span></div></div>);
      setIsMessageBoxVisible(true); setActiveImg(ErrorImg); return;
    }
    if (!testName.trim()) {
      setMessageBox(<div className="Container-messageBOX"><div className="messagebox-insider1"><span>Test Name is required.</span></div></div>);
      setIsMessageBoxVisible(true); setActiveImg(ErrorImg); return;
    }
    if (!testWindowStart || !testWindowEnd) {
      setMessageBox(<div className="Container-messageBOX"><div className="messagebox-insider1"><span>Test Window Start and End are required.</span></div></div>);
      setIsMessageBoxVisible(true); setActiveImg(ErrorImg); return;
    }
    if (!duration) {
      setMessageBox(<div className="Container-messageBOX"><div className="messagebox-insider1"><span>Duration is required.</span></div></div>);
      setIsMessageBoxVisible(true); setActiveImg(ErrorImg); return;
    }
    if (folderName.trim() && savedLevel2Id && !savedLevel3Id) {
      setMessageBox(
        <div className="Container-messageBOX">
          <div className="messagebox-insider1">
            <span>You have only selected till Level 2 in folder structure, do you want to continue?</span>
          </div>
          <div className="messagebox-insider2" style={{ display: "flex", gap: "10px" }}>
            <button className="messagebox-cancel-btn-ok" onClick={() => { setIsMessageBoxVisible(false); proceedSave(); }}>YES</button>
            <button className="messagebox-cancel-btn-ok" onClick={() => setIsMessageBoxVisible(false)}>NO</button>
          </div>
        </div>
      );
      setIsMessageBoxVisible(true);
      setActiveImg(WarnningIcon);
      return;
    }
    proceedSave();
  };

  const proceedSave = async () => {
    const subjectsPayload = markingSchemeFromAPI.map((entry) => {
      const id = entry.subject_superset_id;
      return {
        subject_superset_id: id,
        marking_scheme: [{
          ms_id_sec_a: selectedMarkingSchemes?.[`${id}-0`] ?? entry.ms_id_sec_a ?? null,
          ms_id_sec_b: entry.ms_id_sec_b != null ? (selectedMarkingSchemes?.[`${id}-1`] ?? entry.ms_id_sec_b) : null,
          ms_id_sec_c: entry.ms_id_sec_c != null ? (selectedMarkingSchemes?.[`${id}-2`] ?? entry.ms_id_sec_c) : null,
          ms_id_sec_d: entry.ms_id_sec_d != null ? (selectedMarkingSchemes?.[`${id}-3`] ?? entry.ms_id_sec_d) : null,
        }],
      };
    });

    const payload = {
      ts_id:             selectedTestSeriesId,
      ques_paper_id:     Number(quesPaperIdParam),
      test_name:         testName.trim(),
      test_desc:         testDescription.trim() || testName.trim(),
      test_window_start: testWindowStart,
      test_window_end:   testWindowEnd,
      duration_mins:     parseInt(duration) || 0,
      no_of_sets:        numberOfSets || 1,
      status:            scheduleStatus,
      instructions_html: instructionsHtml || null,
      test_level1_id:    savedLevel1Id,
      test_level2_id:    savedLevel2Id,
      test_level3_id:    savedLevel3Id,
      cancel_reason:     null,
      test_term_date:    null,
      shuffle_subjects:  isAITS ? shuffleSubjects  : false,
      shuffle_questions: isAITS ? shuffleQuestions : false,
      shuffle_options:   isAITS ? shuffleOptions   : false,
      username:          userName || "",
      subjects:          subjectsPayload,
      course_plan_ids:     selectedPlanIds,
    };

    try {
      const result = await PUT.withToken(
        `${EndPoints.PRISM_UPDATE_TEST_SCHEDULE}?ques_paper_id=${quesPaperIdParam}`,
        payload,
        { setMessageBox, setIsMessageBoxVisible, setActiveImg, ErrorImg }
      );
      if (result?.status === 200) {
        setMessageBox(<div className="Container-messageBOX"><div className="messagebox-insider1"><span>{result.message || "Test schedule updated successfully!"}</span></div></div>);
        setIsMessageBoxVisible(true); setActiveImg(SuccessImg);
        setTimeout(() => navigate(-1), 1000);
      }
    } catch (e) { console.error("Error updating:", e); }
  };

  const handleCancelTestSchedule = async (comment) => {
    const payload = { username: userName, test_schedule_id: Number(testScheduleId), comment };
    try {
      const response = await PUT.withToken(
        EndPoints.PRISM_CANCEL_TEST_SCHEDULE,
        payload,
        { setMessageBox, setIsMessageBoxVisible, setActiveImg, ErrorImg }
      );
      setShowCancelModal(false);
      const success = response?.status === 200;
      setMessageBox(
        <div className="Container-messageBOX">
          <div className="messagebox-insider1">
            <span>{success ? "Test schedule cancelled successfully." : (response?.message || "An error occurred.")}</span>
          </div>
        </div>
      );
      setActiveImg(success ? SuccessImg : ErrorImg);
      setIsMessageBoxVisible(true);
      if (success) setTimeout(() => { setIsMessageBoxVisible(false); navigate(-1); }, 1500);
    } catch (err) {
      setMessageBox(<div className="Container-messageBOX"><span>Unexpected error: {err.message}</span></div>);
      setActiveImg(ErrorImg); setIsMessageBoxVisible(true);
    }
  };

  // ── PREVIEW handlers ───────────────────────────────────────────────────────

  const handlePreviewClick = () => {
    if ((numberOfSets || 1) > 1) {
      setSelectedSetForPreview("A");
      setShowSetModal(true);
    } else {
      handlePreview(null); // no_of_sets == 1: don't send set_names
    }
  };

  const handlePreview = async (setName) => {
    if (!quesPaperIdParam) return;
    // When no_of_sets == 1, omit set_names param entirely
    const previewUrl = setName
      ? `${EndPoints.PRISM_GET_FULL_QUESTION_PAPER_FOR_TEST_BY_QUES_PAPER_AND_SET}?ques_paper_id=${quesPaperIdParam}&set_names=${encodeURIComponent(setName)}`
      : `${EndPoints.PRISM_GET_FULL_QUESTION_PAPER_FOR_TEST_BY_QUES_PAPER_AND_SET}?ques_paper_id=${quesPaperIdParam}`;

    setPreviewLoading(true);
    try {
      const result = await GET.withToken(previewUrl, { setMessageBox, setIsMessageBoxVisible, setActiveImg, ErrorImg });
      if (result?.status === 200) {
        setPreviewData({
          ques_paper_info: result.ques_paper_info,
          sets: result.sets,
        });
        setShowPreviewPopup(true);
      } else {
        setMessageBox(<div className="Container-messageBOX"><div className="messagebox-insider1"><span>{result?.message || "Failed to load preview."}</span></div></div>);
        setIsMessageBoxVisible(true); setActiveImg(ErrorImg);
      }
    } catch (e) {
      console.error("Preview error:", e);
    } finally {
      setPreviewLoading(false);
    }
  };

  // ═══════════════════════════════════════════════════════════════════════════
  //  RENDER
  // ═══════════════════════════════════════════════════════════════════════════

  const inputStyle = {
    width: "100%", padding: "8px 10px",
    border: "1px solid var(--DppInputBorder, #d0d0d0)",
    borderRadius: "0px",
    fontSize: "14px", boxSizing: "border-box",
    backgroundColor: "var(--DppInputBackground, #fff)",
    color: "var(--Gray-2, #6A6A6A)",
  };
  const disabledStyle = {
    ...inputStyle,
    opacity: 0.55, cursor: "not-allowed",
    backgroundColor: "var(--DppDropdownBackground, #f5f5f5)",
  };
  const labelStyle = { fontSize: "14px", color: "var(--DppLabelText, #6A6A6A)", display: "block", marginBottom: "5px" };

  const SectionHeader = ({ title, visible, onToggle }) => (
    <div className="Header-1-C424342" style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "5px" }}>
      <span>{title}</span>
      {visible
        ? <img src={MinusImg} alt="collapse" style={{ cursor: "pointer", width: "24px", height: "10px" }} onClick={onToggle} />
        : <div className="plus" style={{ cursor: "pointer", fontSize: "28px", width: "24px", height: "24px", display: "flex", alignItems: "center", justifyContent: "center", color: "var(--Gray-2, #6A6A6A)", fontWeight: "bold" }} onClick={onToggle}>+</div>
      }
    </div>
  );

  return (
    <>
      <div className="Leftmargin-Main-DIV">

        {/* ── top bar ── */}
        <div style={{ position: "sticky", top: 0, backgroundColor: "white", zIndex: 1 }}>
          <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: "20px", width: "98%" }}>
            <div style={{ fontSize: "30px", color: `${Colors.color1}`, fontWeight: "400", whiteSpace: "nowrap" }}>
              Test Scheduling
            </div>
            <div>
              <div className="row-cs-uni">
                <button className="create-test-section-btn" style={{ marginRight: "18px", boxShadow: "0px 4px 4px 0px #00000040" }} onClick={() => navigate(-1)}>
                  CANCEL
                </button>
                {!isCancelled && (
                  <button className="create-test-section-btn" style={{ marginRight: "18px" }} onClick={() => setShowCancelModal(true)}>
                    DELETE
                  </button>
                )}
                <button
                  className="create-test-section-btn"
                  style={{ marginRight: "18px", boxShadow: "0px 4px 4px 0px #00000040", cursor: isCancelled ? "not-allowed" : "pointer", opacity: isCancelled ? 0.6 : 1 }}
                  onClick={!isCancelled ? handleSave : undefined}
                  disabled={isCancelled}
                >
                  SAVE
                </button>
                <button
                  className="create-test-section-btn"
                  style={{ marginRight: "0px", opacity: previewLoading ? 0.6 : 1, cursor: previewLoading ? "wait" : "pointer" }}
                  onClick={!previewLoading ? handlePreviewClick : undefined}
                  disabled={previewLoading}
                >
                  {previewLoading ? "LOADING..." : "PREVIEW"}
                </button>
              </div>
            </div>
          </div>
        </div>

        <SectionHeader title="TEST DETAILS" visible={detailsVisible} onToggle={() => setDetailsVisible((v) => !v)} />

        {detailsVisible && (
          <div className="Body-1-C424342" style={{ paddingBottom: 16 }}>
            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", columnGap: "24px", rowGap: "8px", paddingRight: "5.5px" }}>

              <div>
                <ReflectDropdown label="Test Series" style={{ width: "100%" }}
                  setSelected={() => {}} selected={selectedTestSeriesId}
                  options={[{ label: "-None-", id: 0 }, ...allTestSeries.map((ts) => ({ label: `${ts.ts_name} - ${ts.course_name || ""}`, id: ts.ts_id }))]}
                  isRequired={false} isDisabled={true}
                />
              </div>
              <div>
                <InputComponent label="Description" style={{ width: "100%" }} value={testSeriesDescription} isRequired={false} disable={true} />
              </div>
              <div>
                <DropDown3 label="Course" style={{ width: "100%" }} setSelected={() => {}} selected={courseOpted}
                  options={courses.map((c) => ({ label: c.course_name, id: c.course_id }))} isRequired={false} disabled={true} />
              </div>

              <div>
                <InputComponent label="Question Paper Name" style={{ width: "100%" }} value={quesPaperName} isRequired={false} disable={true} />
              </div>
              <div>
                <InputComponent label="Question Paper Description" style={{ width: "100%" }} value={quesPaperDescription} isRequired={false} disable={true} />
              </div>
              <div>
                <InputComponent label="Subjects" style={{ width: "100%" }} value={testSeriesSubjects} isRequired={false} disable={true} icon={introgativeImgBlue} />
              </div>

              <div>
                <InputComponent label="Question Paper Created By" style={{ width: "100%" }} value={quesPaperCreatedBy} isRequired={false} disable={true} />
              </div>
              <div>
                <label style={labelStyle}>Test Name <span style={{ color: "red" }}>*</span></label>
                <input type="text" style={isCancelled ? disabledStyle : inputStyle} value={testName}
                  placeholder="Enter test name" disabled={isCancelled} onChange={(e) => setTestName(e.target.value)} />
              </div>
              <div>
                <label style={labelStyle}>Description</label>
                <input type="text" style={isCancelled ? disabledStyle : inputStyle} value={testDescription}
                  placeholder="Enter description" disabled={isCancelled} onChange={(e) => setTestDescription(e.target.value)} />
              </div>

              <div>
                <label style={labelStyle}>Test Window Start <span style={{ color: "red" }}>*</span></label>
                <input type="datetime-local" style={isCancelled ? disabledStyle : inputStyle}
                  value={testWindowStart} disabled={isCancelled} onChange={(e) => setTestWindowStart(e.target.value)} />
              </div>
              <div>
                <label style={labelStyle}>Test Window End <span style={{ color: "red" }}>*</span></label>
                <input type="datetime-local" style={isCancelled ? disabledStyle : inputStyle}
                  min={testWindowStart || getCurrentDateTime()} value={testWindowEnd} disabled={isCancelled}
                  onChange={(e) => setTestWindowEnd(e.target.value)} />
              </div>
              <div style={{ position: "relative" }}>
                <label style={labelStyle}>
                  Folder Name {!isAITS && <span style={{ color: "red" }}>*</span>}
                </label>
                <div ref={folderPickerRef} style={{ position: "relative" }}>
                  <input
                    type="text"
                    style={!isCancelled && !isAITS ? { ...inputStyle, paddingRight: "30px" } : { ...disabledStyle, paddingRight: "30px" }}
                    value={folderPickerOpen ? folderSearchText : folderName}
                    placeholder="Select or search folder..."
                    disabled={isCancelled || isAITS}
                    onChange={(e) => {
                      setFolderSearchText(e.target.value);
                      setExpandedLevel1(null); setExpandedLevel2(null);
                      if (!folderPickerOpen) setFolderPickerOpen(true);
                    }}
                    onFocus={() => { if (!isCancelled && !isAITS) { setFolderPickerOpen(true); setFolderSearchText(""); } }}
                  />
                  <span
                    onClick={() => { if (!isCancelled && !isAITS) { setFolderPickerOpen((v) => !v); setFolderSearchText(""); setExpandedLevel1(null); setExpandedLevel2(null); } }}
                    style={{ position: "absolute", right: "10px", top: "50%", transform: "translateY(-50%)", color: "var(--Gray-2, #6A6A6A)", cursor: "pointer", fontSize: "11px" }}
                  >▼</span>
                </div>

                {folderPickerOpen && !isAITS && !isCancelled && (
                  <div ref={folderDropdownRef} style={{ position: "absolute", top: "100%", left: 0, zIndex: 9999, marginTop: "2px", minWidth: "220px" }}>
                    {folderSearchText.trim() ? (
                      <div style={{ backgroundColor: "var(--DppInputBackground, #fff)", border: "1px solid var(--DppInputBorder, #ddd)", borderRadius: "0px", boxShadow: "0 4px 12px rgba(0,0,0,0.15)", maxHeight: "220px", overflowY: "auto", width: "360px" }}>
                        {(() => {
                          const term = folderSearchText.toLowerCase();
                          const results = [];
                          folderLevelData.forEach((l1) => {
                            (l1.level2 || []).forEach((l2) => {
                              const path2 = `${l1.name || "Level 1"} > ${l2.name || "Level 2"}`;
                              if ((l2.name || "").toLowerCase().includes(term)) results.push({ path: path2, l1Id: l1.test_level1_id, l2Id: l2.test_level2_id, l3Id: null });
                              (l2.level3 || []).forEach((l3) => {
                                const path3 = `${path2} > ${l3.name || "Level 3"}`;
                                if ((l3.name || "").toLowerCase().includes(term)) results.push({ path: path3, l1Id: l1.test_level1_id, l2Id: l2.test_level2_id, l3Id: l3.test_level3_id });
                              });
                            });
                          });
                          if (!results.length) return <div style={{ padding: "12px", color: "var(--Gray-2, #6A6A6A)", fontSize: "14px", textAlign: "center" }}>No results found</div>;
                          return results.map((r, i) => (
                            <div key={i}
                              onClick={() => { setFolderName(r.path); setSavedLevel1Id(r.l1Id); setSavedLevel2Id(r.l2Id); setSavedLevel3Id(r.l3Id); setFolderPickerOpen(false); setFolderSearchText(""); }}
                              style={{ padding: "8px 12px", cursor: "pointer", borderBottom: "1px solid var(--DppDropdownItemBorder, #f0f0f0)", fontSize: "14px", color: "var(--Gray-2, #6A6A6A)" }}
                              onMouseEnter={(e) => e.currentTarget.style.backgroundColor = "var(--DppDropdownHoverBackground, #f0f7ff)"}
                              onMouseLeave={(e) => e.currentTarget.style.backgroundColor = "var(--DppInputBackground, #fff)"}>
                              {r.path}
                            </div>
                          ));
                        })()}
                      </div>
                    ) : (
                      <div style={{ display: "flex", alignItems: "flex-start" }}>
                        <div style={{ backgroundColor: "var(--DppInputBackground, #fff)", border: "1px solid var(--DppInputBorder, #ddd)", borderRadius: "0px", boxShadow: "0 4px 12px rgba(0,0,0,0.15)", width: "170px", maxHeight: "220px", overflowY: "auto" }}>
                          {folderLevelData.length === 0
                            ? <div style={{ padding: "12px", color: "var(--Gray-2, #6A6A6A)", fontSize: "14px" }}>No folders available</div>
                            : folderLevelData.map((l1) => (
                              <div key={l1.test_level1_id}
                                onMouseEnter={() => { setExpandedLevel1(l1.test_level1_id); setExpandedLevel2(null); }}
                                style={{ padding: "8px 10px", backgroundColor: expandedLevel1 === l1.test_level1_id ? "var(--DppDropdownHoverBackground, #f0f7ff)" : "var(--DppInputBackground, #fff)", cursor: "default", display: "flex", justifyContent: "space-between", alignItems: "center", borderBottom: "1px solid var(--DppDropdownItemBorder, #f0f0f0)", fontSize: "14px", color: "var(--Gray-2, #6A6A6A)", fontWeight: "500" }}>
                                <span style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{l1.name || "(No name)"}</span>
                                {(l1.level2 || []).length > 0 && <span style={{ fontSize: "9px", color: "var(--Gray-2, #6A6A6A)", flexShrink: 0, marginLeft: "4px" }}>▶</span>}
                              </div>
                            ))
                          }
                        </div>

                        {expandedLevel1 && (() => {
                          const l1 = folderLevelData.find((x) => x.test_level1_id === expandedLevel1);
                          if (!l1?.level2?.length) return null;
                          return (
                            <div style={{ backgroundColor: "var(--DppInputBackground, #fff)", border: "1px solid var(--DppInputBorder, #ddd)", borderRadius: "0px", boxShadow: "0 4px 12px rgba(0,0,0,0.15)", width: "170px", maxHeight: "220px", overflowY: "auto", marginLeft: "3px" }}>
                              {l1.level2.map((l2) => (
                                <div key={l2.test_level2_id}
                                  onMouseEnter={() => setExpandedLevel2(l2.test_level2_id)}
                                  onClick={() => { const path = `${l1.name || "L1"} > ${l2.name || "L2"}`; setFolderName(path); setSavedLevel1Id(l1.test_level1_id); setSavedLevel2Id(l2.test_level2_id); setSavedLevel3Id(null); setFolderPickerOpen(false); setExpandedLevel1(null); setExpandedLevel2(null); }}
                                  style={{ padding: "8px 10px", backgroundColor: expandedLevel2 === l2.test_level2_id ? "var(--DppDropdownHoverBackground, #f0f7ff)" : "var(--DppInputBackground, #fff)", cursor: "pointer", display: "flex", justifyContent: "space-between", alignItems: "center", borderBottom: "1px solid var(--DppDropdownItemBorder, #f0f0f0)", fontSize: "14px", color: "var(--Gray-2, #6A6A6A)" }}>
                                  <span style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{l2.name || "(No name)"}</span>
                                  {(l2.level3 || []).length > 0 && <span style={{ fontSize: "9px", color: "var(--Gray-2, #6A6A6A)", flexShrink: 0, marginLeft: "4px" }}>▶</span>}
                                </div>
                              ))}
                            </div>
                          );
                        })()}

                        {expandedLevel2 && (() => {
                          const l1 = folderLevelData.find((x) => x.test_level1_id === expandedLevel1);
                          const l2 = l1?.level2?.find((x) => x.test_level2_id === expandedLevel2);
                          if (!l2?.level3?.length) return null;
                          return (
                            <div style={{ backgroundColor: "var(--DppInputBackground, #fff)", border: "1px solid var(--DppInputBorder, #ddd)", borderRadius: "0px", boxShadow: "0 4px 12px rgba(0,0,0,0.15)", width: "170px", maxHeight: "220px", overflowY: "auto", marginLeft: "3px" }}>
                              {l2.level3.map((l3) => (
                                <div key={l3.test_level3_id}
                                  onClick={() => { const path = `${l1.name || "L1"} > ${l2.name || "L2"} > ${l3.name || "L3"}`; setFolderName(path); setSavedLevel1Id(l1.test_level1_id); setSavedLevel2Id(l2.test_level2_id); setSavedLevel3Id(l3.test_level3_id); setFolderPickerOpen(false); setExpandedLevel1(null); setExpandedLevel2(null); }}
                                  style={{ padding: "8px 10px", cursor: "pointer", borderBottom: "1px solid var(--DppDropdownItemBorder, #f0f0f0)", fontSize: "14px", color: "var(--Gray-2, #6A6A6A)" }}
                                  onMouseEnter={(e) => e.currentTarget.style.backgroundColor = "var(--DppDropdownHoverBackground, #f0f7ff)"}
                                  onMouseLeave={(e) => e.currentTarget.style.backgroundColor = "var(--DppInputBackground, #fff)"}>
                                  <span style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", display: "block" }}>{l3.name || "(No name)"}</span>
                                </div>
                              ))}
                            </div>
                          );
                        })()}
                      </div>
                    )}
                  </div>
                )}
              </div>

              <div>
                <label style={labelStyle}>Duration (mins) <span style={{ color: "red" }}>*</span></label>
                <input type="number" style={isCancelled ? disabledStyle : inputStyle} value={duration}
                  placeholder="In minutes" disabled={isCancelled} onChange={(e) => setDuration(e.target.value)} />
              </div>
              <div>
                <ReflectDropdown label="No. of Sets" style={{ width: "100%" }}
                  options={[1,2,3,4,5,6].map((n) => ({ label: String(n), id: n }))}
                  selected={numberOfSets}
                  setSelected={(val) => setNumberOfSets(val)}
                  isDisabled={isCancelled || !isAITS}
                />
              </div>
              <div>
                <ReflectDropdown label="Shuffle Subject" style={{ width: "100%" }}
                  options={[{ label: "No", id: 0 }, { label: "Yes", id: 1 }]}
                  selected={shuffleSubjects ? 1 : 0}
                  setSelected={(val) => setShuffleSubjects(Boolean(val))}
                  isDisabled={isCancelled || !isAITS}
                />
              </div>

              <div>
                <ReflectDropdown label="Shuffle Question" style={{ width: "100%" }}
                  options={[{ label: "Yes", id: 1 }, { label: "No", id: 0 }]}
                  selected={shuffleQuestions ? 1 : 0}
                  setSelected={(val) => setShuffleQuestions(Boolean(val))}
                  isDisabled={isCancelled || !isAITS}
                />
              </div>
              <div>
                <ReflectDropdown label="Shuffle Option" style={{ width: "100%" }}
                  options={[{ label: "No", id: 0 }, { label: "Yes", id: 1 }]}
                  selected={shuffleOptions ? 1 : 0}
                  setSelected={(val) => setShuffleOptions(Boolean(val))}
                  isDisabled={isCancelled || !isAITS}
                />
              </div>
              <div />

              <div style={{ gridColumn: "1 / -1" }}>
                <TextEditor templates={testTemplates} value={instructionsHtml}
                  setValue={isCancelled ? () => {} : setInstructionsHtml} />
              </div>

            </div>
          </div>
        )}

        <div style={{ marginTop: "20px" }}>
          <SectionHeader title="COURSE PLANS" visible={coursePlansVisible} onToggle={() => setCoursePlansVisible((v) => !v)} />

          {coursePlansVisible && (
            <div className="Body-1-C424342" style={{ paddingBottom: 16 }}>
              <div style={{ paddingRight: "5.5px" }}>
                <CoursePlanTable
                  coursePlans={coursePlans}
                  selectedPlanIds={selectedPlanIds}
                  setSelectedPlanIds={isCancelled ? () => {} : setSelectedPlanIds}
                />
              </div>
            </div>
          )}
        </div>

        <div style={{ marginTop: "20px" }}>
          <SectionHeader title="MARKING SCHEME" visible={markingSchemeVisible} onToggle={() => setMarkingSchemeVisible((v) => !v)} />

          {markingSchemeVisible && (
            <div className="Body-1-C424342" style={{ padding: "15px", color: `${Colors.color1}`, marginBottom: "10px" }}>
              {markingSchemeFromAPI.length === 0 ? (
                <div style={{ color: "var(--Gray-2, #6A6A6A)", fontSize: "14px", padding: "8px 0" }}></div>
              ) : (
                <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", columnGap: "24px", rowGap: "8px", paddingRight: "5.5px" }}>
                  {markingSchemeFromAPI
                    .slice()
                    .sort((a, b) => (a.subject_superset_name || "").localeCompare(b.subject_superset_name || ""))
                    .map((entry) => {
                      const id   = entry.subject_superset_id;
                      const name = entry.subject_superset_name || "";
                      const sectionsToRender = ["a", "b", "c", "d"].filter((char, idx) => {
                        return idx === 0 || entry[`ms_id_sec_${char}`] != null;
                      });

                      return sectionsToRender.map((char, idx) => {
                        const stateKey   = `${id}-${idx}`;
                        const selectedId = selectedMarkingSchemes?.[stateKey] ?? entry[`ms_id_sec_${char}`] ?? null;
                        const scheme     = markingSchemeList.find((ms) => ms.ms_id === selectedId);
                        const sectionLabel = char.toUpperCase();

                        return (
                          <React.Fragment key={`${id}-${char}`}>
                            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: "12px", minWidth: 0 }}>
                              <span style={{ fontSize: "14px", color: "var(--Gray-2, #6A6A6A)", whiteSpace: "nowrap", flexShrink: 0 }}>
                                {name} - {sectionLabel}
                              </span>
                              <div style={{ width: "300px", flexShrink: 0 }}>
                                <ReflectDropdown
                                  style={{ width: "100%" }}
                                  options={markingSchemeList.map((ms) => ({ label: ms.ms_name, id: ms.ms_id }))}
                                  selected={selectedId}
                                  setSelected={(val) => handleMarkingSchemeChange(id, idx, val)}
                                  isDisabled={isCancelled}
                                />
                              </div>
                            </div>
                            <div style={{ display: "flex", alignItems: "center", fontSize: "14px", color: "var(--Gray-2, #6A6A6A)", minWidth: 0, overflow: "hidden" }}>
                              <span style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                                {scheme ? `${scheme.expression} ; ${scheme.ms_desc}` : "—"}
                              </span>
                            </div>
                            <div />
                          </React.Fragment>
                        );
                      });
                    })}
                </div>
              )}
            </div>
          )}
        </div>

        <div style={{ height: "80px" }} />
      </div>

      {/* ── Set Selection Modal (shown when no_of_sets > 1) ── */}
      {showSetModal && (
        <div
          style={{ position: "fixed", top: 0, left: 0, right: 0, bottom: 0, backgroundColor: "rgba(0,0,0,0.7)", display: "flex", justifyContent: "center", alignItems: "center", zIndex: 9999 }}
          onClick={() => setShowSetModal(false)}
        >
          <div
            style={{ backgroundColor: "white", borderRadius: "12px", width: "90%", maxWidth: "500px", display: "flex", flexDirection: "column", boxShadow: "0 10px 40px rgba(0,0,0,0.3)", overflow: "hidden" }}
            onClick={(e) => e.stopPropagation()}
          >
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "10px 18px", borderBottom: "1px solid #e0e0e0", backgroundColor: "#f8f9fa", borderTopLeftRadius: "12px", borderTopRightRadius: "12px" }}>
              <h2 style={{ margin: 0, fontSize: "16px", fontWeight: "600", color: "#333" }}>Question Paper Print Preview</h2>
              <button style={{ background: "none", border: "none", fontSize: "20px", cursor: "pointer", color: "#666", width: "32px", height: "32px" }} onClick={() => setShowSetModal(false)}>✕</button>
            </div>
            <div style={{ padding: "25px", backgroundColor: "#f8f9fa", border: "2px solid #e0e0e0", margin: "15px", borderRadius: "8px" }}>
              <h3 style={{ margin: "0 0 15px 0", fontSize: "14px", fontWeight: "600", color: "#333" }}>Select Set</h3>
              <div style={{ display: "flex", gap: "15px", flexWrap: "wrap" }}>
                {Array.from({ length: numberOfSets || 1 }, (_, i) => String.fromCharCode(65 + i)).map((set) => (
                  <label key={set} style={{ display: "flex", alignItems: "center", gap: "8px", cursor: "pointer", fontSize: "14px", padding: "10px 16px", borderRadius: "6px", fontWeight: "500", minWidth: "70px", justifyContent: "center" }}>
                    <input
                      type="radio"
                      name="previewSet"
                      value={set}
                      checked={selectedSetForPreview === set}
                      onChange={(e) => setSelectedSetForPreview(e.target.value)}
                      style={{ cursor: "pointer", width: "18px", height: "18px", accentColor: "#4CAF50" }}
                    />
                    <span style={{ userSelect: "none" }}>{set}</span>
                  </label>
                ))}
              </div>
            </div>
            <div style={{ display: "flex", justifyContent: "flex-end", marginRight: "15px", marginBottom: "10px" }}>
              <button
                onClick={() => { setShowSetModal(false); handlePreview(selectedSetForPreview); }}
                style={{ padding: "12px 30px", fontSize: "14px", backgroundColor: "#fff", color: "#0b0b0bb9", border: "1px solid black", cursor: "pointer", borderRadius: "6px", fontWeight: "600", display: "flex", alignItems: "center", gap: "8px", boxShadow: "0 4px 4px rgba(46,45,45,0.3)" }}
              >
                🖥️ PREVIEW
              </button>
            </div>
          </div>
        </div>
      )}

      {/* ── Preview Popup ── */}
      {showPreviewPopup && previewData && (
        <div
          style={{
            position: "fixed", top: 0, left: 0, right: 0, bottom: 0,
            backgroundColor: "rgba(0,0,0,0.5)", zIndex: 9999,
            display: "flex", alignItems: "center", justifyContent: "center",
          }}
          onClick={() => setShowPreviewPopup(false)}
        >
          <button
            onClick={(e) => { e.stopPropagation(); setShowPreviewPopup(false); }}
            style={{
              position: "absolute", top: "20px", right: "20px",
              background: "var(--DppInputBackground, #fff)", border: "1px solid var(--DppInputBorder, #d0d0d0)", borderRadius: "50%",
              width: "36px", height: "36px", fontSize: "20px", cursor: "pointer",
              display: "flex", alignItems: "center", justifyContent: "center",
              color: "#666", fontWeight: "bold", zIndex: 10000,
            }}
          >
            ×
          </button>

          <div
            onClick={(e) => e.stopPropagation()}
            style={{
              width: "60vw", height: "80vh", backgroundColor: "var(--DppInputBackground, #fff)",
              borderRadius: "8px", display: "flex", flexDirection: "column",
              overflow: "hidden", boxShadow: "0 8px 32px rgba(0,0,0,0.2)",
            }}
          >
            <div style={{
              position: "sticky", top: 0, backgroundColor: "var(--DppInputBackground, #fff)", zIndex: 2,
              padding: "16px 20px", borderBottom: "1px solid var(--DppInputBorder, #d0d0d0)",
            }}>
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <h3 style={{ margin: 0, color: "var(--Gray-2, #6A6A6A)" }}>
                  Preview Question Paper
                  <span
                    style={{ marginLeft: "10px", cursor: "pointer", fontSize: "12px", textDecoration: "underline" }}
                    onClick={() => setShowOptions((prev) => !prev)}
                  >
                    {showOptions ? "Hide Options" : "Show Options"}
                  </span>
                </h3>
              </div>
              <div style={{ display: "flex", justifyContent: "space-between", flexWrap: "wrap", marginTop: "10px", fontSize: "14px" }}>
                <div style={{ flex: "0 0 48%" }}>
                  <p style={{ marginBottom: "8px" }}><span>Question Paper:</span> {previewData.ques_paper_info?.ques_paper_name || quesPaperName || "N/A"}</p>
                  <p><span>Course:</span> {courseOpted?.label || "N/A"}</p>
                </div>
                <div style={{ flex: "0 0 48%" }}>
                  <p style={{ marginBottom: "8px" }}><span>Test Name:</span> {testName || "N/A"}</p>
                  <p><span>Subjects:</span> {testSeriesSubjects || "N/A"}</p>
                </div>
              </div>
            </div>

            <div style={{ overflowY: "auto", padding: "20px", flex: 1 }}>
              {previewData.sets?.map((set, setIdx) => (
                <div key={set.set_name || setIdx} style={{ marginBottom: "30px" }}>
                  {(numberOfSets || 1) > 1 && (
                    <h3 style={{ textAlign: "center", color: "var(--Gray-2, #6A6A6A)", marginBottom: "16px", borderBottom: "2px solid var(--DppSectionBorder, #eeeeee)", paddingBottom: "8px" }}>
                      Set {set.set_name}
                    </h3>
                  )}

                  {set.subjects?.map((subject, subjIdx) => (
                    <div key={subject.subject_superset_id || subjIdx} style={{ marginBottom: "24px" }}>
                      <h4 style={{ color: "var(--Gray-2, #6A6A6A)", marginBottom: "12px", padding: "8px 12px" }}>
                        {subject.subject_superset_name || `Subject ${subjIdx + 1}`}
                      </h4>

                      {subject.sections?.map((section, secIdx) => (
                        <div key={section.section_name || secIdx} style={{ marginBottom: "16px", paddingLeft: "12px" }}>
                          <h5 style={{ color: "var(--Gray-2, #6A6A6A)", marginBottom: "16px" }}>
                            Section {section.section_name}
                          </h5>

                          {section.questions?.length > 0 ? (
                            <ul style={{ listStyle: "none", padding: 0 }}>
                              {section.questions.map((ques, qIdx) => (
                                <li key={ques.ques_id || qIdx} style={{ marginBottom: "16px", paddingLeft: "8px" }}>
                                  <div style={{ marginBottom: "4px", fontSize: "14px", color: "var(--Gray-2, #6A6A6A)" }}>
                                    {qIdx + 1}.{" "}
                                    {(() => {
                                      const raw = ques.question_text || ques.ques_text || "";
                                      const decoded = he.decode(raw);
                                      const segments = decoded.split(/(imgsrc=[^\s]+)/g);
                                      return segments.map((seg, i) => {
                                        if (seg.startsWith("imgsrc=")) {
                                          const url = seg.replace("imgsrc=", "");
                                          return <img key={i} src={url} alt={`Q${qIdx + 1}`} style={{ maxHeight: "100px", width: "auto", margin: "5px", verticalAlign: "middle" }} />;
                                        }
                                        return <span key={i}><Latex>{seg}</Latex></span>;
                                      });
                                    })()}
                                  </div>

                                  {showOptions && ques.options?.length > 0 && (
                                    <div style={{ display: "flex", gap: "20px", flexWrap: "wrap", paddingLeft: "20px", marginTop: "5px" }}>
                                      {[0, 1].map((col) => (
                                        <ul key={col} style={{ flex: "1 1 45%", paddingLeft: "20px", listStyleType: "disc" }}>
                                          {ques.options
                                            .filter((_, idx) => idx % 2 === col)
                                            .map((option, idx) => {
                                              const globalIndex = col + idx * 2;
                                              return (
                                                <li key={option.option_id || globalIndex} style={{ padding: "4px 0", fontSize: "13px", color: "#555" }}>
                                                  {String.fromCharCode(65 + globalIndex).toLowerCase()}.{" "}
                                                  {(() => {
                                                    const raw = option.option_text || "";
                                                    const decoded = he.decode(raw);
                                                    const segments = decoded.split(/(imgsrc=[^\s]+)/g);
                                                    return segments.map((seg, i) => {
                                                      if (seg.startsWith("imgsrc=")) {
                                                        const url = seg.replace("imgsrc=", "");
                                                        return <img key={i} src={url} alt="option" style={{ maxHeight: "80px", width: "auto", margin: "3px", verticalAlign: "middle" }} />;
                                                      }
                                                      return <span key={i}><Latex>{seg}</Latex></span>;
                                                    });
                                                  })()}
                                                </li>
                                              );
                                            })}
                                        </ul>
                                      ))}
                                    </div>
                                  )}
                                </li>
                              ))}
                            </ul>
                          ) : (
                            <p style={{ color: "var(--Gray-2, #6A6A6A)", fontSize: "14px" }}>No questions in this section.</p>
                          )}
                        </div>
                      ))}
                    </div>
                  ))}
                </div>
              ))}
            </div>
          </div>
        </div>
      )}

      <RejectModal
        isOpen={showCancelModal}
        onClose={() => setShowCancelModal(false)}
        onSubmit={handleCancelTestSchedule}
        title="Cancel Test Schedule"
        placeholder="Enter reason for cancelling the test schedule..."
        setMessageBox={setMessageBox}
        setIsMessageBoxVisible={setIsMessageBoxVisible}
        setActiveImg={setActiveImg}
        errorImg={ErrorImg}
      />
    </>
  );
};

export default TestSchedulingClone;